import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import moment from 'moment';
import { ConfigServer } from "../../data/config";
import { validateBacterium, unValidateBacterium, releaseBacterium, unreleaseBacterium } from '../../services/micro/micro'
import { useForm } from '../forms/useForm';
import { cedimi, labcen, sharp, demo, pyrsa, semlab, hsjs, buap, insan, qfb } from '../../constant/globalConstantsTypeClients';
import { answerSurvey } from '../../services/templateSurvey/templateConfiguration';


export const useCaptureResults = () => {
    const { nim } = useParams();
    const history = useHistory();

    //*VARIABLES LOCAL STORAGE
    let id_branch = localStorage.getItem('branchId');
    let credit_payment = localStorage.getItem('credit_payment');
    let enable_interface_imagenology = localStorage.getItem('enable_interface_imagenology');
    let _url_helen = localStorage.getItem('url_helen');
    let _capture_lock = localStorage.getItem('capture_lock');




    enable_interface_imagenology = (enable_interface_imagenology === "true" ? true : false);
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()

    const [profiles, setProfiles] = useState([]);
    const [sections, setSections] = useState([]);
    const [patient, setPatient] = useState({});
    console.log("🐴 patient", patient);

    const [listDoctors, setListDoctor] = useState([]);
    const [sendDoctor, setSendDoctor] = useState(false);
    const [observations, setObservations] = useState("");
    const [commentsFlebo, setCommentsFlebo] = useState("");
    const [hospitalization, setHospitalization] = useState(false);
    const [hospitalizationComment, setHospitalizationComment] = useState("");
    const [hasHospitalization, setHasHospitalization] = useState(false);
    const [analytes, setAnalytes] = useState([]);
    const [workOrderId, setWorkOrderId] = useState(0);
    const [type_file, setType_file] = useState("");
    const [workMedicalOrderPDF, setworkMedicalOrderPDF] = useState("");
    const [workMedicalOrderPDFDownload, setworkMedicalOrderPDFDownload] = useState("");
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [workMedicalOrderPDFLoading, setworkMedicalOrderPDFLoading] = useState(false);
    //const [workMedicalOrder, setMedicalOrder] = useState("");
    const [workMedicalOrder, setWorkMedicalOrder] = useState("");
    const [analytesComplex, setAnalytesComplex] = useState([]);
    const [printAvailable, setPrintAvailable] = useState(false);
    const [dobleValidacion, setDobleValidacion] = useState(false);
    const [resultsPartial, setResultsPartial] = useState(false);
    const [paid, setpaid] = useState(false);
    const [idp, setIdp] = useState(0)
    const [commentsPrintResult, setCommentsPrintResult] = useState("");
    const [funcionesFormulas, setFuncionesFormulas] = useState([]);
    const [company, setCompany] = useState([]);
    const [codeAgreement, setCodeAgreement] = useState([])
    const [allValidated, setAllValidated] = useState(false);

    const nameUser = localStorage.getItem("nameUser");
    const userSections = localStorage.getItem("sections");
    const userFilterSections = localStorage.getItem("filter_sections");
    // console.log("🥘 userFilterSections", userFilterSections);

    const [nimPatient, setNimPatient] = useState([]);
    const [loadingExport, setLoadingExport] = useState(false);

    const [microBacteriums, setMicroBacteriums] = useState([]);
    const [microAntibiograms, setMicroAntibiograms] = useState([]);
    const [microAntibiotics, setMicroAntibiotics] = useState([]);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle1, setModalTitle1] = useState("");
    const [typeModal, setTypeModal] = useState("view");
    const [typeModalMedical, setTypeModalMedical] = useState("view2");
    const [modalMedical, setModalMedical] = useState(false);

    const [backNim, setBackNim] = useState(null);
    const [nextNim, setNextNim] = useState(null);

    // * MICROBACTERIUMS
    const [presumptive, setPresumptive] = useState([]);
    const [taptopStyle, setTapTopStyle] = useState("none")

    const [loadingButton, setLoadingButton] = useState(false);
    const [modalRelease, setModalRelease] = useState(false);
    const [loadingRelease, setLoadingRelease] = useState(false);

    const [modalViewImagenology, setModalViewImagenology] = useState(false);
    const [modalTitleImg, setModalTitleImg] = useState("");
    const [documentImagenology, setDocumentImagenology] = useState("");

    // * COMMENT GLOBAL MICROBILOGY
    const [microComments, setMicroComments] = useState([])


    //* Modal Global Comment
    const [modalTableGlobalComment, setModalTableGlobalComment] = useState(false);
    const [modalCrudComment, setModalCrudComment] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comments, setComments] = useState([]);
    const [idCommentText, setIdCommentText] = useState([])

    const [microBinnacleCedimi, setMicroBinnacleCedimi] = useState([]);

    // ? CONFIGURATION QUESTION SAMPLING

    const [dataQuestionSampling, setDataQuestionSampling] = useState([]);

    const [modalPrintI, setModalPrintI] = useState(false);
    const [typeModalPrintI, setTypeModalPrintI] = useState("viewPrintI");
    const [dataExams, setdataExams] = useState([]);
    const [id_workorder_print, setid_workorder_print] = useState(0);
    const [is_micro, setIs_micro] = useState(false);
    // console.log("🚀 ~ useCaptureResults ~ is_micro:", is_micro)

    // ? CURVES
    const [listCurves, setListCurves] = useState([]);
    const [disabledInputFollowUp, setDisabledInputFollowUp] = useState(false);
    const [disableMethodInput, setDisableMethodInput] = useState(false);

    const [loadingValidateProfileC, setLoadingValidateProfileC] = useState(false);
    const [loadingRemoveCapture, setLoadingRemoveCapture] = useState({});
    const [loadingValidateCapture, setLoadingValidateCapture] = useState({});
    const [loadingReleaseExamCapture, setLoadingReleaseExamCapture] = useState({});

    const [processingValidation, setProcessingValidation] = useState(false);
    const processingValidationRef = React.useRef(false);

    const beginProcessingValidation = () => {
        if (processingValidationRef.current) return false;

        processingValidationRef.current = true;
        setProcessingValidation(true);
        return true;
    };

    const endProcessingValidation = () => {
        processingValidationRef.current = false;
        setProcessingValidation(false);
    };

    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);


    //? REPORT STUDIES FOR PATIENT

    const [historicoData, setHistoricoData] = useState([]);
    const [historicoRaw, setHistoricoRaw] = useState(null);
    const [visibleSidebar, setVisibleSidebar] = useState(false);
    const [selectedExam, setSelectedExam] = useState(null);
    const [loadingHistorico, setLoadingHistorico] = useState(false);

    const [showResistanceView, setShowResistanceView] = useState(false);
    const [showReloadLoader, setShowReloadLoader] = useState(false);

    //? Hospitalized
    const [visibleHospitalizationHistory, setVisibleHospitalizationHistory] = useState(false);
    const [hospitalizationHistory, setHospitalizationHistory] = useState([]);
    const [loadingHospitalizationHistory, setLoadingHospitalizationHistory] = useState(false);
    // console.log("🚀 ~ listCurves:", listCurves)


    const executeScroll = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    const handleScroll = () => {
        if (window.scrollY > 600) {
            setTapTopStyle("block")
        } else {
            setTapTopStyle("none")
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        handleScroll();
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const toggle = () => {
        setModal(!modal);
    }

    const openDialog = (title, mode) => {
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const toggleMedical = () => {
        setModalMedical(!modalMedical);
    }

    const handleCreate = () => {
        setTypeModalMedical("view2");
        setModalTitle1("Orden Medica")
        previewWorkOrder();
        toggleMedical()
    }

    const getViewPreview = (_valid) => {

        if (_valid === true) {

            previewProgressWorkOrder(_valid)

        }
        else {

            previewWorkOrder();
        }
        setTypeModal("view");
        openDialog();
        toggle();
    }

    const toggleLoadingButton = (status) => {
        setLoadingButton(status)
    }


    const openDialogRelease = (title, mode) => {
        setLoadingRelease(false);
        setModalRelease(true);
    };

    const closeDialogRelease = () => {
        setModalRelease(false);
    };


    const toggleModalViewImagenology = () => {
        setModalViewImagenology(!modalViewImagenology);
    }

    const handleGetDocumentImagenology = async (id_exam, id_work_order_exam) => {

        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/Exam/DownloadResultsImagenology/" + id_exam + "/" + id_work_order_exam, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el documento");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                let objectUrl = window.URL.createObjectURL(blob);

                setDocumentImagenology(objectUrl);
                toggleModalViewImagenology();
                setModalTitleImg("visualizar documento");
            })
    }

    const getFuncionesFormula = async () => {
        let requestOptions = {
            method: 'GET',
        };
        const respuesta = await sendRequest(requestOptions, 'Exam/GetFuncionesFormula');
        if (respuesta.code === 200) {
            setFuncionesFormulas(respuesta.data)
            return respuesta.data;
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getFuncionesFormula);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Captura de resultados", respuesta.data.msg);
        }
        else {
            createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
        }
    }

    const [loadingPatient, setLoadingPatient] = useState(false);
    const [pdf_historic, setPdf_historic] = useState("");
    const [historicMode, setHistoricMode] = useState("");
    const [pdf_without_letter, setWithoutLetter] = useState("");
    const [idWChart, setIdWChart] = useState(0)

    let activeToma = localStorage.getItem('enable_tracking_toma');
    const [countSample, setCountSample] = useState("")
    const [validCount, setValidCount] = useState(false)

    const [listAnswer, setListAnswer] = useState([])


    useEffect(() => {
        if (_url_helen === insan || _url_helen === semlab || _url_helen === pyrsa) {
            getListAnswer(nim)
        }
    }, [])




    //!INFORMATION GENERAL PATIENT
    const getData = async (funcionesFormulasAux = []) => {

        setLoadingPatient(false);

        let nuevas_secciones = JSON.parse(userSections);
        let filtro_secciones = JSON.parse(userFilterSections);

        if (_url_helen !== cedimi && _url_helen !== sharp && _url_helen !== labcen) {
            const idsSectionsLocal = localStorage.getItem("ids_sections");
            if (idsSectionsLocal) {
                nuevas_secciones = JSON.parse(idsSectionsLocal);
            }
        } else {
            nuevas_secciones = JSON.parse(userSections || "[]");
            filtro_secciones = JSON.parse(userFilterSections || "[]");

            nuevas_secciones = nuevas_secciones.filter(x =>
                filtro_secciones.find(y => y.id_section === x)
            );
        }

        let payload = {
            "nim": nim,
            "sections_array": nuevas_secciones,
            "id_branch": id_branch
        }

        let data = JSON.stringify(payload);

        let requestOptions = {
            method: 'POST',
            body: data

        };

        const respuesta = await sendRequest(requestOptions, "Exam/GetCaptureResults");
        // console.log("🚀 ~ getData ~ respuesta:", respuesta)

        setLoadingPatient(true);
        if (respuesta.code === 200) {

            if (respuesta.data.observations !== null) {
                setObservations(respuesta.data.observations);
            }

            if (respuesta.data.comments !== null) {
                setCommentsFlebo(respuesta.data.comments);
            }

            if (respuesta.data.pdf_with_letter !== null) {
                setPdf_historic(respuesta.data.pdf_with_letter)

            }

            if (respuesta.data.historic_mode !== null) {
                setHistoricMode(respuesta.data.historic_mode)

            }

            if (respuesta.data.pdf_without_letter !== null) {
                setWithoutLetter(respuesta.data.pdf_without_letter)

            }

            if (respuesta.data.show_print_micro_binnacle_cedimi !== null) {
                setMicroBinnacleCedimi(respuesta.data.show_print_micro_binnacle_cedimi)
            }

            if (respuesta.data.is_micro !== null) {
                setIs_micro(respuesta.data.is_micro);
                setTimeout(() => gotoNim(respuesta.data.nim, respuesta.data.is_micro), 100);
            }

            if (respuesta.data.hospitalized !== null) {
                setHospitalization(respuesta.data.hospitalized);
            }

            if (respuesta.data.hospitalization_comment !== null) {
                setHospitalizationComment(respuesta.data.hospitalization_comment);
            }

            if (respuesta.data.has_hospitalization !== null) {
                setHasHospitalization(respuesta.data.has_hospitalization);
            }

            if (activeToma !== "True") {
                let totalPerfiles = 0;
                let totalExamenes = 0;
                let totalCheckFalse = 0;
                let totalExamenesFinal = 0;
                let examenCheckTrueCount = 0;
                let complete = true;

                if (respuesta && respuesta.data) {

                    if (Array.isArray(respuesta.data.profiles)) {
                        respuesta.data.profiles.forEach((perfil) => {

                            totalPerfiles++;

                            if (Array.isArray(perfil.exams)) {
                                perfil.exams.forEach((examen) => {

                                    totalExamenes++;

                                    if (examen.check_forwarded === false) {
                                        totalCheckFalse++;
                                        complete = false;
                                    } else {
                                        examenCheckTrueCount++;
                                    }
                                });
                            }
                        });
                    }

                    if (Array.isArray(respuesta.data.exams)) {
                        respuesta.data.exams.forEach((examen) => {

                            totalExamenes++;

                            if (examen.check_forwarded === false) {
                                totalCheckFalse++;
                                complete = false;
                            } else {
                                examenCheckTrueCount++;
                            }
                        });
                    }

                    totalExamenesFinal = totalCheckFalse + examenCheckTrueCount;

                    const totalExamenesCompleto = examenCheckTrueCount;
                    const totalExamenesPendiente = totalCheckFalse;

                    console.log(`Total de perfiles: ${totalPerfiles}`);
                    console.log(`Total de exámenes: ${totalExamenes}`);
                    console.log(`Total de exámenes con 'check_forwarded: false': ${totalCheckFalse}`);
                    console.log(`Total final de exámenes: ${totalExamenesCompleto} de ${totalExamenes}`);
                    console.log(`¿Todos los exámenes completos? ${complete ? "Sí" : "No"}`);

                    console.log("aca pasaria el artemis");


                    setCountSample(`${(totalExamenes - totalExamenesCompleto)} de ${totalExamenes}`)
                    setValidCount(complete)
                } else {
                    console.log("No hay datos válidos en 'respuesta.data'");
                }

            }
            // else {
            //     let totalPerfiles = 0;
            //     let totalExamenes = 0;
            //     let totalCheckFalse = 0;
            //     let totalExamenesFinal = 0;
            //     let examenCheckTrueCount = 0;
            //     let complete = true;

            //     if (respuesta && respuesta.data) {

            //         if (Array.isArray(respuesta.data.profiles)) {
            //             respuesta.data.profiles.forEach((perfil) => {

            //                 totalPerfiles++;

            //                 if (Array.isArray(perfil.exams)) {
            //                     perfil.exams.forEach((examen) => {

            //                         totalExamenes++;

            //                         // SI YA SE ENVIÓ MUESTRA
            //                         const tieneMuestra = examen.is_send3 !== null;

            //                         if (examen.check_forwarded === false && !tieneMuestra) {
            //                             totalCheckFalse++;
            //                             complete = false;
            //                         } else {
            //                             examenCheckTrueCount++;
            //                         }
            //                     });
            //                 }
            //             });
            //         }



            //         if (Array.isArray(respuesta.data.exams)) {

            //             respuesta.data.exams.forEach((examen) => {

            //                 if (examen.curves?.length > 0) {

            //                     totalExamenes += examen.curves.length;

            //                     const curvasCompletas = examen.curves.filter(
            //                         curve => curve.is_send === true
            //                     ).length;

            //                     const curvasPendientes =
            //                         examen.curves.length - curvasCompletas;

            //                     totalCheckFalse += curvasPendientes;
            //                     examenCheckTrueCount += curvasCompletas;

            //                     if (curvasPendientes > 0) {
            //                         complete = false;
            //                     }
            //                 }

            //                 else {

            //                     totalExamenes++;

            //                     const tieneMuestra =
            //                         examen.is_send3 !== null &&
            //                         examen.is_send3 === true;

            //                     if (
            //                         examen.check_forwarded === false &&
            //                         !tieneMuestra
            //                     ) {
            //                         totalCheckFalse++;
            //                         complete = false;
            //                     }
            //                     else {
            //                         examenCheckTrueCount++;
            //                     }
            //                 }
            //             });
            //         }

            //         totalExamenesFinal = totalCheckFalse + examenCheckTrueCount;

            //         const totalExamenesCompleto = examenCheckTrueCount;
            //         const totalExamenesPendiente = totalCheckFalse;

            //         console.log(`Total de exámenes: ${totalExamenes}`);
            //         console.log(`Pendientes: ${totalExamenesPendiente}`);
            //         console.log(`Completos: ${totalExamenesCompleto}`);

            //         setCountSample(
            //             `${totalExamenesPendiente} de ${totalExamenes}`
            //         );

            //         setValidCount(complete);


            //     } else {
            //         console.log("No hay datos válidos en respuesta.data");
            //     }
            // }


            else {
                let totalPerfiles = 0;
                let totalExamenes = 0;
                let totalCheckFalse = 0;
                let examenCheckTrueCount = 0;
                let complete = true;

                if (respuesta && respuesta.data) {

                    if (Array.isArray(respuesta.data.profiles)) {
                        respuesta.data.profiles.forEach((perfil) => {

                            totalPerfiles++;

                            if (Array.isArray(perfil.exams)) {
                                perfil.exams.forEach((examen) => {

                                    totalExamenes++;

                                    const tieneMuestra = examen.is_send3 === true;

                                    if (!tieneMuestra) {
                                        totalCheckFalse++;
                                        complete = false;
                                    } else {
                                        examenCheckTrueCount++;
                                    }
                                });
                            }
                        });
                    }

                    if (Array.isArray(respuesta.data.exams)) {

                        respuesta.data.exams.forEach((examen) => {

                            if (examen.curves?.length > 0) {

                                totalExamenes += examen.curves.length;

                                const curvasCompletas = examen.curves.filter(
                                    curve => curve.is_send === true
                                ).length;

                                const curvasPendientes =
                                    examen.curves.length - curvasCompletas;

                                totalCheckFalse += curvasPendientes;
                                examenCheckTrueCount += curvasCompletas;

                                if (curvasPendientes > 0) {
                                    complete = false;
                                }
                            }
                            else {

                                totalExamenes++;

                                const tieneMuestra = examen.is_send3 === true;

                                if (!tieneMuestra) {
                                    totalCheckFalse++;
                                    complete = false;
                                } else {
                                    examenCheckTrueCount++;
                                }
                            }
                        });
                    }

                    const totalExamenesCompleto = examenCheckTrueCount;
                    const totalExamenesPendiente = totalCheckFalse;

                    console.log(`Total de exámenes: ${totalExamenes}`);
                    console.log(`Pendientes: ${totalExamenesPendiente}`);
                    console.log(`Completos: ${totalExamenesCompleto}`);

                    setCountSample(
                        `${totalExamenesPendiente} de ${totalExamenes}`
                    );

                    setValidCount(complete);

                } else {
                    console.log("No hay datos válidos en respuesta.data");
                }
            }



            setCommentsPrintResult(respuesta.data.comments_print_result);
            setNimPatient(respuesta.data.nim)
            setDataQuestionSampling(respuesta.data.questions)

            setSendDoctor(respuesta.data.send_doctor);
            setListDoctor(respuesta.data.listDoctors);
            setCompany(respuesta.data.name_company);
            setIdWChart(respuesta.data.id_work_order ?? 0)
            setCodeAgreement(respuesta?.data?.code_agreement ?? "N/A")

            let validacion_impresion = true;
            let secciones = [];
            setWorkOrderId(respuesta.data.id_work_order);
            setWorkMedicalOrder(respuesta.data.medical_order);
            setType_file(respuesta.data.type_file);

            setIdp(respuesta.data.patient.id_patient)

            // handleGetHospitalizationHistory(
            //     respuesta.data.patient.id_patient
            // );

            if (respuesta.data.exams.length > 0) {
                respuesta.data.exams.forEach(exam => {

                    let seccion = secciones.find(x => x.id === exam.id_section);
                    if (seccion === undefined) {
                        secciones.push({
                            id: exam.id_section,
                            name: exam.name_section,
                            exams: [exam],
                            profiles: []
                        });
                    } else {
                        secciones.map(obj => {
                            if (obj.id === exam.id_section) {
                                obj.exams = [
                                    ...obj.exams,
                                    exam
                                ]
                            }
                            return obj;
                        })
                    }
                });
            }

            setSections(secciones);
            // let cumpleanios = new Date(respuesta.data.patient.birthday);
            // let age = calculateAge(cumpleanios);
            // let format_age = "";
            // let days_age = 0;
            // if (age <= 0) {
            //     format_age = calculateAgeMonths(cumpleanios);
            //     let fecha1 = moment(respuesta.data.patient.birthday);
            //     let fecha2 = moment();
            //     days_age = fecha2.diff(fecha1, 'days');
            // }

            // let paciente = {
            //     ...respuesta.data.patient,
            //     age: age,
            //     format_age: format_age,
            //     days_age: days_age
            // }

            // setPatient(paciente);

            let paciente = {
                ...respuesta.data.patient,
                format_age: respuesta.data.patient.age_text ?? ""
            };

            setPatient(paciente);
            // ! ANALYTES
            let analitos = [];

            // ! BACTERIUMS
            let microbacterias = [];

            // ! PRESUMTIVE RESULTS
            let presumtive1 = [];

            // ! GLOBAL COMMENT
            let global_comment = []



            if (respuesta.data.profiles.length > 0) {

                respuesta.data.profiles.forEach(profile => {

                    let readyToValidateProfile = true;
                    let readyToReleaseProfile = true;
                    profile.exams.forEach(exam => {
                        //END SECTION PARA MICROBIOLOGIA CLINICA
                        if (!enable_interface_imagenology && exam.is_imagenology) {
                            if (exam.imagenology !== null) {
                                if (exam.imagenology.isCaptured === false) {
                                    readyToValidateProfile = false;
                                }
                                if (exam.imagenology.userValidate === null) {
                                    readyToReleaseProfile = false
                                }
                            }
                        }

                        exam.analytes !== null && exam.analytes.forEach(element => {
                            if (element.required) {
                                if (element.isCaptured === false) {
                                    readyToValidateProfile = false;
                                }
                                if (element.userValidate === null) {
                                    readyToReleaseProfile = false;
                                }
                            }
                        });
                        if (!exam.isRelease) {
                            validacion_impresion = false;
                        }

                        let exam_method = "";
                        let id_exam_method = "";
                        let id_method = "";
                        if (exam.method_selected > 0) {
                            exam_method = exam.method_selected;
                        } else {
                        }

                        if (!exam.is_imagenology) {
                            try {
                                id_exam_method = exam.methods[0].id_exam_method;
                                id_method = exam.methods[0].id_method;
                            } catch (error) {
                            }
                        }

                        exam.analytes.forEach(analyte => {

                            if (analyte.id_type_analyte === 7) {
                                getDataAnalyteComplex(analyte.id_analyte, funcionesFormulasAux);
                            }

                            if (analyte.compute !== "" && analyte.id_type_analyte === 7) {
                                let formula = analyte.compute;
                                if (funcionesFormulasAux.length > 0) {
                                    funcionesFormulasAux.forEach(form => {
                                        let form_js = form.toLowerCase();
                                        for (let index = 0; index < 5; index++) {
                                            formula = formula.replaceAll(form, "Math." + form_js);
                                        }
                                    })
                                } else {
                                    funcionesFormulas.forEach(form => {
                                        let form_js = form.toLowerCase();
                                        for (let index = 0; index < 5; index++) {
                                            formula = formula.replaceAll(form, "Math." + form_js);
                                        }
                                    })
                                }
                                analyte.compute = formula;
                            }

                            let valor_nuevo = "";
                            let nuevo_comentario = '';
                            let symbol = "";

                            let print_chart = analyte.print_graph ?? false;
                            let is_interface = false;
                            let is_file = false;
                            let file_base64 = "";

                            if (analyte.capture !== null) {
                                if (analyte.id_type_analyte === 1 || analyte.id_type_analyte === 6 || analyte.id_type_analyte === 14) {
                                    valor_nuevo = analyte.capture.text;
                                    symbol = analyte.capture.symbols;
                                    if (analyte.id_type_analyte === 14) {
                                        is_file = true;
                                        file_base64 = analyte.capture.file_base64;
                                    }

                                } else {
                                    valor_nuevo = analyte.capture.number;
                                    symbol = analyte.capture.symbols;
                                }
                                is_interface = analyte.capture.is_interface;
                                nuevo_comentario = analyte.capture.comments;
                                print_chart = analyte.capture.print_chart;

                            }
                            else {

                                if (exam.id_estatus_exam === 4) {
                                    valor_nuevo = { "id": 4 };
                                }
                            }

                            if (analyte.id_type_analyte === 14) {
                                is_file = true;
                            }

                            if (profile.curves !== null && profile.curves !== undefined && profile.curves.length > 0) {
                                profile.curves.forEach((curva, llaveCurva) => {
                                    if (analyte.sub_id === curva.time.value) {
                                        analitos.push({
                                            "id": analyte.id_analyte,
                                            "sub_id": curva.time.value,
                                            "capture": valor_nuevo,
                                            "send": analyte.send,
                                            "id_exam": exam.id_exam,
                                            "id_type_analyte": analyte.id_type_analyte,
                                            "id_exam_method": exam_method,
                                            "id_exam_method_main": id_method,
                                            "id_app_code_or_method_exam": id_exam_method,
                                            "comment": nuevo_comentario,
                                            "id_work_order_exam": exam.id_work_order_exam,
                                            "is_exam": false,
                                            "is_interface": is_interface,
                                            "integers": analyte.integers,
                                            "decimals": analyte.decimals,
                                            "id_profile": profile.id_profile,
                                            "file_base64": analyte.file_base64,
                                            "is_file": analyte.is_file,
                                            "print_chart": print_chart,
                                            "is_captured": analyte.isCaptured,
                                            "symbols": symbol
                                        });
                                        analyte.id_analyte_references = analyte.id_analyte_references;
                                    }
                                });
                            } else {
                                let dataMeter = {
                                    "id": analyte.id_analyte,
                                    "capture": valor_nuevo,
                                    "send": analyte.send,
                                    "id_exam": exam.id_exam,
                                    "id_type_analyte": analyte.id_type_analyte,
                                    "id_exam_method": exam_method,
                                    "id_exam_method_main": id_method,
                                    "id_app_code_or_method_exam": id_exam_method,
                                    "comment": nuevo_comentario,
                                    "id_work_order_exam": exam.id_work_order_exam,
                                    "is_exam": false,
                                    "id_profile": profile.id_profile,
                                    "id_section": exam.id_section,
                                    "is_interface": is_interface,
                                    "integers": analyte.integers,
                                    "decimals": analyte.decimals,
                                    "is_file": is_file,
                                    "file_base64": file_base64,
                                    "print_chart": print_chart,
                                    "is_captured": analyte.isCaptured,
                                    "symbols": symbol
                                };
                                analyte.id_analyte_references = analyte.id_analyte_references;
                                analitos.push(dataMeter);
                            }
                        })


                        // ! BACTERIUMS
                        if (exam.bacteriums !== undefined && exam.bacteriums !== null) {

                            exam.bacteriums = exam.bacteriums.forEach((_bacter, _key) => {

                                // ? CONFIGURATION INPUTS
                                const _id_mic_bacterium = { "value": _bacter?.id_mic_bacterium, "label": _bacter?.label_mic_bacterium };
                                const _id_bacterium_count_text = { "value": _bacter?.id_bacterium_count_text, "label": _bacter?.label_bacterium_count_text };
                                const _id_mic_stain_gram = { "value": _bacter?.id_mic_stain_gram, "label": _bacter?.label_mic_stain_gram };
                                const _id_mic_antibiogram = { "value": _bacter?.id_mic_antibiogram, "label": _bacter?.label_mic_antibiogram };


                                const _ids_resistance_mechanisms = _bacter?.resistance_mechanisms.map(_mechanism => ({
                                    value: _mechanism?.id_resistance_mechanism,
                                    label: _mechanism?.resistance_mechanism
                                }));

                                let _new_array = []

                                if (_bacter.bacterium_texts.length > 0) {
                                    _bacter.bacterium_texts.forEach((_find, key) => {
                                        _new_array.push({
                                            "id_work_order_exam_bacterium_text": _find.id_work_order_exam_bacterium_text,
                                            "text": _find.text,
                                            "id": key + 1
                                        })
                                    });
                                }

                                microbacterias.push({
                                    id_temp: _key + 1,
                                    "id_work_order_exam": exam.id_work_order_exam,
                                    "id_mic_stain_gram": _id_mic_stain_gram,
                                    "id_mic_bacterium": _id_mic_bacterium,
                                    "quantity_number": _bacter?.quantity_number,
                                    "id_bacterium_count_text": _bacter?.label_bacterium_count_text === null ? null : _id_bacterium_count_text,
                                    "comment_resistance_mechanism": _bacter?.comment_resistance_mechanism,
                                    "type_bacterium": _bacter?.type_bacterium,
                                    "id_mic_antibiogram": _id_mic_antibiogram,
                                    "ids_resistance_mechanisms": _ids_resistance_mechanisms,
                                    "bacterium_texts": _new_array ?? [],
                                    "antibiotics": _bacter?.antibiotics ?? [],
                                    "view1": _bacter.type_bacterium === 1 ? true : false,
                                    "view2": _bacter.type_bacterium === 2 ? true : false,
                                    "view3": _bacter.type_bacterium === 3 ? true : false,
                                    "update": true,
                                    "released_at": _bacter?.released_at ?? "",
                                    "released_by": _bacter?.released_by ?? "",
                                    "validated_at": _bacter?.validated_at ?? "",
                                    "validated_by": _bacter?.validated_by ?? "",
                                    "userValidate": exam.analytes?.find(
                                        a => a.userValidate !== null
                                    )?.userValidate ?? null,

                                });
                            });
                            exam.bacteriums = microbacterias
                        }

                        // ! PRESUMPTIVE_RESULTS
                        if (exam.presumptive_results !== undefined && exam.presumptive_results !== null) {
                            // ? OBJECT RESULTS   
                            const groupedResults = {};
                            exam.presumptive_results.presumptives.forEach((_presumptive, key) => {

                                // ? INPUTS PRESUMTIVE RESULTS
                                const tincion = { "value": _presumptive?.id_mic_stain, "label": _presumptive?.label_mic_stain };
                                const resultado = { "value": _presumptive?.id_mic_stain_result, "label": _presumptive?.label_mic_stain_result };
                                const mic = { "value": _presumptive?.id_mic_bacterium, "label": _presumptive?.label_mic_bacterium };

                                // ? VALIDATE OBJECT NEW
                                if (!groupedResults[_presumptive.id_work_order_exam]) {
                                    groupedResults[_presumptive.id_work_order_exam] = {
                                        id: key + 100,
                                        id_work_order_exam: exam?.presumptive_results.id_work_order_exam,
                                        close_capture_presumptive_result: exam?.presumptive_results.close_capture_presumptive_result,
                                        print_presumptive: exam?.presumptive_results.print_presumptive,
                                        presumptives: []
                                    };
                                }

                                groupedResults[_presumptive?.id_work_order_exam].presumptives.push({
                                    id: key + 1,
                                    id_presumptive_result: _presumptive?.id_presumptive_result,
                                    id_mic_stain: tincion,
                                    id_mic_stain_result: resultado,
                                    id_mic_bacterium: mic,
                                    label_mic_stain: _presumptive?.label_mic_stain,
                                    label_mic_stain_result: _presumptive?.label_mic_stain_result,
                                    label_mic_bacterium: _presumptive?.label_mic_bacterium,
                                    observations: _presumptive?.observations,
                                    time: _presumptive?.time,
                                    id_work_order_exam: _presumptive?.id_work_order_exam,
                                    isEdit: true,
                                    user_release: _presumptive?.user_release,
                                    user_validate: _presumptive?.user_validate,
                                    validate_at: _presumptive?.validate_at,
                                    print_result: _presumptive?.print_result
                                });
                            });

                            const _new_array = Object.values(groupedResults);
                            exam.presumptive_results = _new_array
                            presumtive1.push(_new_array)
                        }

                        // ! GLOBAL COMMENT
                        if (exam?.micro_global_comment !== null || exam?.cedimi_micro_type_result !== null) {
                            let nuevo = {
                                "id": exam.id_work_order_exam + 2,
                                "id_work_order_exam": exam?.id_work_order_exam,
                                "global_comment": exam?.micro_global_comment ?? null,
                                "global_result": exam?.micro_global_result ?? null,
                                "cedimi_micro_type_result": exam?.cedimi_micro_type_result ?? null,
                            };
                            global_comment.push(nuevo)
                        }


                    });
                    profile.readyToValidateProfile = readyToValidateProfile;
                    profile.readyToReleaseProfile = readyToReleaseProfile;
                    profile.id_work_order = respuesta.data.id_work_order;
                });
                setProfiles(respuesta.data.profiles);
            }

            secciones.forEach(seccion => {
                seccion.exams.forEach(exam => {
                    if (!exam.isRelease) {
                        validacion_impresion = false;
                    }
                    let exam_method = "";
                    let id_exam_method = "";
                    let id_method = "";
                    if (exam.method_selected > 0) {
                        exam_method = exam.method_selected;
                    } else {
                    }

                    if (!exam.is_imagenology) {
                        try {
                            id_exam_method = exam.methods[0].id_exam_method;
                            id_method = exam.methods[0].id_method;
                        } catch (error) {
                        }
                    }

                    exam.analytes !== null && exam.analytes.forEach(analyte => {
                        if (analyte.id_type_analyte === 7) {
                            getDataAnalyteComplex(analyte.id_analyte, funcionesFormulasAux);
                        }

                        let valor_nuevo = "";
                        let nuevo_comentario = '';
                        let _symbol = '';

                        let print_chart = analyte.print_graph ?? false;
                        let is_interface = false;
                        let is_file = false;
                        let file_base64 = "";

                        if (analyte.capture !== null) {
                            if (analyte.id_type_analyte === 1 || analyte.id_type_analyte === 6 || analyte.id_type_analyte === 14) {

                                valor_nuevo = analyte.capture.text;

                                if (analyte.id_type_analyte === 14) {
                                    is_file = true;
                                    file_base64 = analyte.capture.file_base64;
                                }

                            } else {
                                valor_nuevo = analyte.capture.number;
                                _symbol = analyte.capture.symbol === "" ? null : analyte.capture.symbol

                            }
                            is_interface = analyte.capture.is_interface;
                            nuevo_comentario = analyte.capture.comments;
                            print_chart = analyte.capture.print_chart;

                        }
                        else {
                            if (exam.id_estatus_exam === 4) {
                                valor_nuevo = { "id": 4 };
                            }

                        }

                        if (analyte.id_type_analyte === 14) {
                            is_file = true;
                        }
                        if (analyte.compute !== "" && analyte.id_type_analyte === 7) {
                            let formula = analyte.compute;
                            if (funcionesFormulasAux.length > 0) {
                                funcionesFormulasAux.forEach(form => {
                                    let form_js = form.toLowerCase();
                                    for (let index = 0; index < 5; index++) {
                                        formula = formula.replaceAll(form, "Math." + form_js);
                                    }
                                })
                            } else {
                                funcionesFormulas.forEach(form => {
                                    let form_js = form.toLowerCase();
                                    for (let index = 0; index < 5; index++) {
                                        formula = formula.replaceAll(form, "Math." + form_js);
                                    }
                                })
                            }
                            analyte.compute = formula;
                        }
                        analitos.push({
                            "id": analyte.id_analyte,
                            "capture": valor_nuevo,
                            "send": analyte.send,
                            "id_exam": exam.id_exam,
                            "id_type_analyte": analyte.id_type_analyte,
                            "id_exam_method": exam_method,
                            "id_exam_method_main": id_method,
                            "id_app_code_or_method_exam": id_exam_method,
                            "decimals": analyte.decimals,
                            "compute": analyte.compute,
                            "variable": (analyte.id_analyte_references !== null ? exam.abbreviation.replaceAll(" ", "").replace(/[^a-zA-Z0-9]/g, '').toLowerCase() : exam.abbreviation.replaceAll(" ", "").replace(/[^a-zA-Z0-9]/g, '').toLowerCase()) + "_" + analyte.code.replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
                            "comment": nuevo_comentario,
                            "id_work_order_exam": exam.id_work_order_exam,
                            "is_exam": true,
                            "id_section": exam.id_section,
                            "is_interface": is_interface,
                            "integers": analyte.integers,
                            "decimals": analyte.decimals,
                            "is_file": is_file,
                            "file_base64": file_base64,
                            "print_chart": print_chart,
                            "is_captured": analyte.isCaptured,
                            "symbol": _symbol

                        });

                        analyte.id_analyte_references = analyte.id_analyte_references;
                    })

                    // ! BACTERIUMS
                    if (exam.bacteriums !== undefined && exam.bacteriums !== null) {

                        exam.bacteriums = exam.bacteriums.forEach((_bacter, _key) => {

                            // ? CONFIGURATION INPUTS
                            const _id_mic_bacterium = { "value": _bacter?.id_mic_bacterium, "label": _bacter?.label_mic_bacterium };
                            const _id_bacterium_count_text = { "value": _bacter?.id_bacterium_count_text, "label": _bacter?.label_bacterium_count_text };
                            const _id_mic_stain_gram = { "value": _bacter?.id_mic_stain_gram, "label": _bacter?.label_mic_stain_gram };
                            const _id_mic_antibiogram = { "value": _bacter?.id_mic_antibiogram, "label": _bacter?.label_mic_antibiogram };


                            const _ids_resistance_mechanisms = _bacter?.resistance_mechanisms.map(_mechanism => ({
                                value: _mechanism?.id_resistance_mechanism,
                                label: _mechanism?.resistance_mechanism
                            }));

                            let _new_array = []

                            if (_bacter.bacterium_texts.length > 0) {
                                _bacter.bacterium_texts.forEach((_find, key) => {
                                    _new_array.push({
                                        "id_work_order_exam_bacterium_text": _find.id_work_order_exam_bacterium_text,
                                        "text": _find.text,
                                        "id": key + 1
                                    })
                                });
                            }

                            microbacterias.push({
                                id_temp: _key + 1,
                                "id_work_order_exam": exam.id_work_order_exam,
                                "id_mic_stain_gram": _id_mic_stain_gram,
                                "id_mic_bacterium": _id_mic_bacterium,
                                "quantity_number": _bacter?.quantity_number,
                                "id_bacterium_count_text": _bacter?.label_bacterium_count_text === null ? null : _id_bacterium_count_text,
                                "comment_resistance_mechanism": _bacter?.comment_resistance_mechanism,
                                "type_bacterium": _bacter?.type_bacterium,
                                "id_mic_antibiogram": _id_mic_antibiogram,
                                "ids_resistance_mechanisms": _ids_resistance_mechanisms,
                                "bacterium_texts": _new_array ?? [],
                                "antibiotics": _bacter?.antibiotics ?? [],
                                "view1": _bacter.type_bacterium === 1 ? true : false,
                                "view2": _bacter.type_bacterium === 2 ? true : false,
                                "view3": _bacter.type_bacterium === 3 ? true : false,
                                "update": true,
                                "released_at": _bacter?.released_at ?? "",
                                "released_by": _bacter?.released_by ?? "",
                                "validated_at": _bacter?.validated_at ?? "",
                                "validated_by": _bacter?.validated_by ?? "",
                                "userValidate": exam.analytes?.find(
                                    a => a.userValidate !== null
                                )?.userValidate ?? null,
                            });
                        });
                        exam.bacteriums = microbacterias
                    }

                    // ! PRESUMPTIVE_RESULTS
                    if (exam.presumptive_results !== undefined && exam.presumptive_results !== null) {
                        // ? OBJECT RESULTS   
                        const groupedResults = {};
                        exam.presumptive_results.presumptives.forEach((_presumptive, key) => {

                            // ? INPUTS PRESUMTIVE RESULTS
                            const tincion = { "value": _presumptive?.id_mic_stain, "label": _presumptive?.label_mic_stain };
                            const resultado = { "value": _presumptive?.id_mic_stain_result, "label": _presumptive?.label_mic_stain_result };
                            const mic = { "value": _presumptive?.id_mic_bacterium, "label": _presumptive?.label_mic_bacterium };

                            // ? VALIDATE OBJECT NEW
                            if (!groupedResults[_presumptive.id_work_order_exam]) {
                                groupedResults[_presumptive.id_work_order_exam] = {
                                    id: key + 100,
                                    id_work_order_exam: exam?.presumptive_results.id_work_order_exam,
                                    close_capture_presumptive_result: exam?.presumptive_results.close_capture_presumptive_result,
                                    print_presumptive: exam?.presumptive_results.print_presumptive,
                                    presumptives: []
                                };
                            }

                            groupedResults[_presumptive?.id_work_order_exam].presumptives.push({
                                id: key + 1,
                                id_presumptive_result: _presumptive?.id_presumptive_result,
                                id_mic_stain: tincion,
                                id_mic_stain_result: resultado,
                                id_mic_bacterium: mic,
                                label_mic_stain: _presumptive?.label_mic_stain,
                                label_mic_stain_result: _presumptive?.label_mic_stain_result,
                                label_mic_bacterium: _presumptive?.label_mic_bacterium,
                                observations: _presumptive?.observations,
                                time: _presumptive?.time,
                                id_work_order_exam: _presumptive?.id_work_order_exam,
                                isEdit: true,
                                user_release: _presumptive?.user_release,
                                user_validate: _presumptive?.user_validate,
                                validate_at: _presumptive?.validate_at,
                                print_result: _presumptive?.print_result
                            });
                        });

                        const _new_array = Object.values(groupedResults);
                        exam.presumptive_results = _new_array
                        presumtive1.push(_new_array)
                    }

                    // ! GLOBAL COMMENT
                    if (exam?.micro_global_comment !== null || exam?.cedimi_micro_type_result !== null) {
                        let nuevo = {
                            "id": exam.id_work_order_exam + 2,
                            "id_work_order_exam": exam?.id_work_order_exam,
                            "global_comment": exam?.micro_global_comment ?? null,
                            "global_result": exam?.micro_global_result ?? null,
                            "cedimi_micro_type_result": exam?.cedimi_micro_type_result ?? null,
                        };
                        global_comment.push(nuevo)
                    }
                })
            });

            //!OBJECT PRESUMTIVE RESULTS
            const presumtive_results_capture = presumtive1.filter(item => Object.keys(item).length !== 0).flat();

            setAnalytes([...analitos]);
            setMicroBacteriums([...microbacterias]);
            setPresumptive([...presumtive_results_capture])
            setDobleValidacion(respuesta.data.doble_validacion);
            setPrintAvailable(respuesta.data.is_released);
            setpaid(respuesta.data.paid);
            setResultsPartial(respuesta.data.results_partial);
            setMicroComments([...global_comment])

            //! CURVES
            let allCurves = [];

            if (respuesta.data.exams && Array.isArray(respuesta.data.exams)) {
                respuesta.data.exams.forEach(exam => {
                    if (exam.curves && Array.isArray(exam.curves) && exam.curves.length > 0) {
                        allCurves.push({
                            id_work_order_exam: exam.id_work_order_exam,
                            id_exam: exam.id_exam,
                            method_selected: exam.method_selected,
                            id_method: exam.methods?.find(m => m.id_exam_method === exam.method_selected)?.id_method || null,
                            name: exam.name,
                            curves: exam.curves
                        });

                    }
                });
            }
            setListCurves(allCurves);
            // console.log("🚀 ~ getData ~ allCurves entra aca curvas:", allCurves)
        }
        else if (respuesta.code === 401) validarSesion(history, respuesta.code, getData);

        else if (respuesta.code === 500) createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
    }


    // * CONFIGURATION DYNAMIC-CONSENT
    const getListAnswer = async (_nimm) => {

        const data = await answerSurvey(_nimm);

        if (data?.code === 200) {
            setListAnswer(data?.data ?? [])
        }
        else setListAnswer([])
    }


    // * CONFIGURATIO ANSWER
    const getAnswerText = (answer) => {

        if (!answer) {
            return "Sin respuesta";
        }

        if (
            Array.isArray(answer.selected_options) &&
            answer.selected_options.length > 0
        ) {
            return answer.selected_options
                .map(option => option.text)
                .filter(Boolean)
                .join(", ");
        }

        if (
            answer.value !== null &&
            answer.value !== undefined &&
            String(answer.value).trim() !== ""
        ) {
            return answer.value;
        }

        return "Sin respuesta";
    };


    // * CARRUSEL
    const [surveyPage, setSurveyPage] = useState(0);

    const surveysPerPage = 2;

    const totalSurveyPages = Math.ceil(
        (listAnswer?.length || 0) / surveysPerPage
    );

    const visibleSurveys = Array.isArray(listAnswer)
        ? listAnswer.slice(
            surveyPage * surveysPerPage,
            surveyPage * surveysPerPage + surveysPerPage
        )
        : [];




    const getDataAnalyteComplex = async (id_analyte, funcionesFormulasAux = []) => {

        let requestOptions = {
            method: 'GET',
        };

        const respuesta = await sendRequest(requestOptions, 'Exam/GetDataAnalyteComplex/' + id_analyte);

        if (respuesta.code === 200) {
            let aux = analytesComplex;
            let datos = respuesta.data;
            let formula = respuesta.data.formula;
            if (funcionesFormulasAux.length > 0) {
                funcionesFormulasAux.forEach(form => {
                    let form_js = form.toLowerCase();
                    formula = formula.replaceAll(form, "Math." + form_js);
                })
            } else {
                funcionesFormulas.forEach(form => {
                    let form_js = form.toLowerCase();
                    formula = formula.replaceAll(form, "Math." + form_js);
                })
            }
            datos.formula = formula;
            aux.push(datos);
            setAnalytesComplex([...aux]);
        }
        else if (respuesta.code === 401) {

            validarSesion(history, respuesta.code, getDataAnalyteComplex);
        }
        else if (respuesta.code === 500) {

            createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
        }
        else createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
    }

    // *cedimi_micro_type_result

    //! SAVE CAPTURE RESULT 'Exam/SaveCaptureResults'
    const saveIndividualAnalyte = async (obj) => {

        let analitos = analytes;

        analitos.forEach(element => {
            if (element.variable !== undefined) {
                if (element.id === obj.id_analyte) {
                    window[element.variable] = obj.valor !== "" && parseFloat(obj.valor);
                } else {
                    window[element.variable] = element.capture !== "" && parseFloat(element.capture);
                }
            }
        });
        analitos.map(x => {

            if (x.id === obj.id_analyte) {
                if (x.sub_id !== undefined) {
                    if (x.sub_id === obj.sub_id) {
                        if (obj.active === true) {
                            return;
                        }

                        x.capture = obj.valor;
                        x.id_exam_method = obj.id_exam_method;
                        x.id_exam_method_main = obj.id_exam_method_main;
                        x.send = obj.send;
                        x.id_app_code_or_method_exam = obj.id_app_code_or_method_exam;
                        x.validate_format = obj.validate_format;
                        x.is_file = obj.is_file;
                        x.id_analyte_age_gender_range = obj.id_analyte_age_gender_range;
                        x.id_analyte_number_alert = obj.id_analyte_number_alert;
                        x.ids_analyte_text_alerts = obj.ids_analyte_text_alerts;
                        x.id_analyte_references = obj.id_analyte_references;
                        x.symbols = obj.symbols

                    }
                } else {
                    if (obj.active === true) {
                        return;
                    }
                    x.capture = obj.valor;
                    x.id_exam_method = obj.id_exam_method;
                    x.id_exam_method_main = obj.id_exam_method_main;
                    x.send = obj.send;
                    x.id_app_code_or_method_exam = obj.id_app_code_or_method_exam;
                    x.validate_format = obj.validate_format;
                    x.is_file = obj.is_file;
                    x.id_analyte_age_gender_range = obj.id_analyte_age_gender_range;
                    x.id_analyte_number_alert = obj.id_analyte_number_alert;
                    x.ids_analyte_text_alerts = obj.ids_analyte_text_alerts;
                    x.id_analyte_references = obj.id_analyte_references;
                    x.symbols = obj.symbols
                }
            }
            if (x.compute !== "" && x.id_type_analyte === 7) {
                let resultado = "";
                if (x.is_interface) {
                    resultado = parseFloat(x.capture);
                }
                else {
                    try {
                        resultado = eval(x.compute);
                    } catch (error) {
                    }
                }

                if (resultado !== "") {
                    if (!isNaN(resultado)) {
                        if (isFinite(resultado)) {
                            if (resultado === 0) {
                                x.capture = resultado;
                            } else {
                                try {
                                    x.capture = resultado.toFixed(x.decimals);
                                } catch (error) {
                                }
                            }
                        }
                    }
                }
            }
            return x;
        })

        analytesComplex.forEach(element => {
            recalculateComplex(analitos);
        });

        if (obj.active === true) {
            let _validAn = analitos
            let _validAnd = _validAn.find(x => x.id === obj.id_analyte);


            if (_validAnd) {
                _validAnd.symbols = obj.symbols
                setAnalytes(
                    _validAnd
                );
            }

        }
        setAnalytes([...analitos]);
    }

    const saveIndividualExamImagenology = async (obj) => {
        let formData = new FormData();


        formData.append("id_work_order", workOrderId);
        formData.append("id_exam", obj.id_exam);
        formData.append("capture", obj.valor);

        let requestOptions = {
            method: 'POST',
            body: formData
        };

        const response = await sendRequest(requestOptions, "Exam/SaveCaptureResultsImagenology", 'multipart/form-data');

        if (response.code === 200) {

            let updateSections = sections;
            let updateProfiles = profiles;

            let validacion_impresion = true;
            updateSections.map(section => {
                if (section.id === obj.id_section) {
                    section.exams.map(exam => {
                        if (exam.id_exam === obj.id_exam && exam.id_work_order_exam === obj.id_work_order_exam) {

                            let captureData = {
                                id_user: 0,
                                name_document: obj.valor
                            };

                            exam.imagenology.capture = captureData;

                            let usersCapture = exam.imagenology.usersCapture;

                            let datetime_actual = moment();

                            let user_capture = {
                                id_work_order_exam_imagenology: Date.now() + "-" + exam.id_exam,
                                username: "",
                                full_name: nameUser,
                                result_capture: obj.valor,
                                date_capture: datetime_actual.format("D/M/YYYY hh:mm a")
                            }

                            if (usersCapture === null || usersCapture === undefined) {
                                usersCapture = [user_capture];
                            }
                            else {
                                let validacion = usersCapture[0];
                                if (validacion.result_capture == user_capture.result_capture) {
                                    usersCapture = [user_capture, ...usersCapture];
                                }
                            }

                            let user_validate = {
                                id_work_order_exam_imagenology: Date.now() + "validate" + exam.id_exam,
                                full_name: nameUser,
                                date_capture: moment().format("D/M/YYYY hh:mm a"),
                                result_capture: "",
                                username: ""
                            };

                            exam.imagenology = {
                                ...exam.imagenology,
                                userValidate: user_validate,
                                usersCapture: usersCapture,
                                isCaptured: true
                            };
                        }

                        if (!exam.isRelease) {
                            validacion_impresion = false;
                        }

                        return exam;
                    });
                }
                return section;
            });

            updateProfiles.map(perfil => {
                if (perfil.id_profile === obj.sectionProfileId) {
                    let readyToValidateProfile = true;
                    let readyToReleaseProfile = true;
                    perfil.exams.map(exam => {
                        if (exam.id_exam === obj.id_exam && exam.id_work_order_exam === obj.id_work_order_exam) {
                            let captureData = {
                                id_user: 0,
                                name_document: obj.valor
                            };

                            exam.imagenology.capture = captureData;

                            let usersCapture = exam.imagenology.usersCapture;
                            let datetime_actual = moment();

                            let user_capture = {
                                "id_work_order_exam_imagenology": Date.now() + "-" + exam.id_exam,
                                username: "",
                                full_name: nameUser,
                                result_capture: obj.valor,
                                date_capture: datetime_actual.format("D/M/YYYY hh:mm a")
                            };

                            if (usersCapture === null || usersCapture === undefined) {
                                usersCapture = [user_capture];
                            }
                            else {
                                let validacion = usersCapture[0];
                                if (validacion.result_capture == user_capture.result_capture) {
                                    usersCapture = [user_capture, ...usersCapture];
                                }
                            }

                            let user_validate = {
                                id_work_order_exam_imagenology: Date.now() + "validate" + exam.id_exam,
                                full_name: nameUser,
                                date_capture: moment().format("D/M/YYYY hh:mm a"),
                                result_capture: "",
                                username: ""
                            };

                            exam.imagenology = {
                                ...exam.imagenology,
                                userValidate: user_validate,
                                usersCapture: usersCapture,
                                isCaptured: true
                            };
                        }

                        if (exam.imagenology.required) {
                            if (exam.imagenology.isCaptured === false) {
                                readyToValidateProfile = false;
                            }

                            if (exam.imagenology.userValidate === null) {
                                readyToReleaseProfile = false;
                            }
                        }
                        return exam;
                    });

                    perfil.readyToValidateProfile = readyToValidateProfile;
                    perfil.readyToReleaseProfile = readyToReleaseProfile;
                }

                return perfil;
            });

            setSections([...updateSections]);
            setProfiles([...updateProfiles]);
            createSweet("success", "success", "Resultado guardado con exito");
        }

    }

    const recalculateComplex = (analitos) => {
        analytesComplex.forEach(element => {
            let resultado = '';
            Object.entries(element.list_analytes).forEach(variable => {
                let valor = "";
                let analyte_aux = analitos.find(q => q.id == variable[0]);
                if (analyte_aux == undefined) {
                    analyte_aux = analitos.find(q => q.id_analyte_references == variable[0]);
                }
                let aux = "";

                try {
                    aux = analyte_aux.capture;
                } catch (error) {
                    console.log(analyte_aux);
                    aux = "";
                }

                if (aux !== "") {
                    if (!isNaN(aux)) {
                        if (isFinite(aux)) {
                            if (aux === 0) {
                                valor = aux;
                            } else {
                                valor = parseFloat(aux);
                            }
                        }
                    }
                }
                else {
                    valor = NaN;
                }
                window[variable[1]] = valor;
            });
            let resultado_final = "";
            let analito_final = analitos.find(a => a.id == element.id_analyte);
            try {
                // console.log(element.formula);
                resultado = eval(element.formula);
            } catch (error) {
                console.log('Error aL EVALUAR LA FORMULA', element.formula);
            }
            // let liberar = false;
            // let intentos = 5;
            // let formula_aux = element.formula;
            // // while (liberar === false && intentos > 0) {
            // for (let indice = 0; indice < 5; indice++) {
            //     try {
            //         //console.log("pas de nuevo", formula_aux, intentos, liberar);
            //         resultado = eval(formula_aux);
            //         //console.log(resultado);
            //         liberar = true;
            //     } catch (error) {
            //         if (error.name === "ReferenceError") {
            //             let hola = error.message.split(" ", 1);
            //             hola = hola[0];
            //             formula_aux = formula_aux.replace(hola, "Math." + hola.toLowerCase());
            //             intentos = intentos - 1;
            //         }
            //         // //console.log(error.name);
            //         // //console.log(error.message);
            //         // //console.log(error.stack);
            //     }
            // }
            // //console.log(resultado, element);
            if (resultado !== "") {
                if (!isNaN(resultado)) {
                    if (isFinite(resultado)) {
                        resultado = parseFloat(resultado);
                        if (resultado === 0) {
                            resultado_final = resultado;
                        } else {
                            resultado_final = resultado.toFixed(analito_final.decimals);
                        }
                    }
                }
            }
            analitos.map(a => {
                if (a.id === element.id_analyte) {
                    a.capture = resultado_final;
                    if (a.id_exam_method === "" || a.id_exam_method === 0) {
                        a.id_exam_method = a.id_exam_method_main;
                    }
                }
                return a;
            })
        });
        // debugger
        setAnalytes([...analitos]);
    }

    const saveAllAnalytes = async () => {

        toggleLoadingButton(true);

        // * VALIDATION PRESUMTIVE
        let _validPresuntives = presumptive.length > 0 ? true : false

        if (_validPresuntives) {
            if (validTestRanges()) {
                toggleLoadingButton(false);
                createSweet("warning", "warning", "Preliminares", "Debe de llenar al menos un campo para poder guardarlo");
                return;
            }
        }

        // * CONFIGURATION ANALYTES
        let analitosSend = [...analytes];
        analitosSend = analitosSend.filter(x => { return x.capture !== "" && x.capture !== null && x.capture !== undefined; });
        analitosSend = analitosSend.filter(x => x.id_exam_method !== "");

        // * CONFIGURATION BACTERIUM
        let _send_Bacterium = microBacteriums;

        _send_Bacterium = _send_Bacterium?.map(bacterium => {
            const filteredAntibiotics = bacterium.antibiotics.filter(antibiotic =>
                (antibiotic.id_antibiotic_bacterium_result !== null && antibiotic.id_antibiotic_bacterium_result !== undefined) || (antibiotic.cim !== "")
            );

            return {
                id_work_order_exam: bacterium?.id_work_order_exam,
                id_mic_stain_gram: bacterium?.id_mic_stain_gram.value,
                id_mic_bacterium: bacterium?.id_mic_bacterium.value,
                quantity_number: bacterium?.quantity_number,
                id_bacterium_count_text: bacterium?.id_bacterium_count_text === null ? null : bacterium?.id_bacterium_count_text.value,
                comment_resistance_mechanism: bacterium?.comment_resistance_mechanism,
                type_bacterium: bacterium?.type_bacterium,
                id_mic_antibiogram: bacterium?.id_mic_antibiogram === null ? null : bacterium?.id_mic_antibiogram.value,
                ids_resistance_mechanisms: bacterium?.ids_resistance_mechanisms.length > 0 ? bacterium?.ids_resistance_mechanisms.map(mechanism => mechanism.value) : [],
                bacterium_texts: bacterium?.bacterium_texts,
                antibiotics: filteredAntibiotics
            };
        });

        // * CONFIGURATION RESULT PRESUNTIVE
        const presumtive_results_capture = presumptive?.map(item => {
            const newItem = { ...item };
            //!FILTER DELETE
            newItem.presumptives = newItem.presumptives.filter(element => !element.idDelete);
            //!VALUE INPUTS 
            newItem.presumptives.forEach(element => {

                //!VALUE INPUTS SENS
                element.id_mic_bacterium1 = element?.id_mic_bacterium;
                element.id_mic_stain1 = element?.id_mic_stain;
                element.id_mic_stain_result1 = element?.id_mic_stain_result;
                //!VALUE RECUPERATE INPUTS
                element.id_mic_bacterium = element?.id_mic_bacterium.value;
                element.id_mic_stain = element?.id_mic_stain.value;
                element.id_mic_stain_result = element?.id_mic_stain_result.value;
            });
            return newItem;
        });

        // * CONFIGURATION COMMENT GLOBAL
        let _send_comment = []

        if (microComments.length > 0) {

            let _valid_array = microComments

            _valid_array.forEach(element => {
                _send_comment.push({
                    id_work_order_exam: element?.id_work_order_exam,
                    micro_global_comment: element?.global_comment ?? null,
                    micro_global_result: element?.global_result ?? null,
                    cedimi_micro_type_result: element?.cedimi_micro_type_result === true ? 1 : element?.cedimi_micro_type_result === false ? 0 : null ?? null
                });
            });
        }

        // if (validateCurves()) {
        //     toggleLoadingButton(false);
        //     createSweet("warning", "warning", "Curvas", "Hay resultados de curvas fuera del rango permitido.");
        //     return;
        // }

        // * Cuves save
        const curves_capture = listCurves?.map(exam => {
            const analyteForExam = analytes.find(a => a.id_exam === exam.id_exam);
            const exam_method_selected = analyteForExam?.id_app_code_or_method_exam ?? exam.method_selected ?? 0;
            return {
                id_work_order_exam: exam.id_work_order_exam,
                id_exam_method: exam_method_selected,
                results: exam.curves
                    .filter(c => c.result !== null && c.result !== '')
                    .map(c => ({
                        id_curve_time: c.id_curve_time,
                        num_sampling: c.num_sampling,
                        result: parseFloat(c.result)
                    }))
            };
        }).filter(x => x.results.length > 0);

        const filter_sections = JSON.parse(localStorage.getItem("filter_sections")) || [];

        // * PAYLOAD SEND
        let payload = {
            "id_work_order": workOrderId,
            "analytes_capture": analitosSend,
            "bacteriums_capture": _send_Bacterium,
            "presumtive_results_capture": presumtive_results_capture,
            "global_comments": _send_comment,
            "curves_capture": curves_capture,
            "filter_sections": filter_sections
        };

        // console.log("🚀 ~ saveAllAnalytes ~ payload:", payload)


        let data = JSON.stringify(payload);

        let requestOptions = {
            method: 'POST',
            body: data
        };

        const clientsWithoutReload = [
            labcen, demo, pyrsa, semlab, hsjs, buap, insan, qfb
        ];

        const shouldReload = !clientsWithoutReload.includes(_url_helen);

        if (shouldReload) {
            setShowReloadLoader(true);
        }

        // //*END PAYLOAD SEND
        const respuesta = await sendRequest(requestOptions, 'Exam/SaveCaptureResults');

        if (respuesta.code === 200) {

            // * UPDATE ANALYTES
            const updateAnalytes = analytes?.map(analyte => {
                if (analitosSend.find(ana => ana?.id === analyte?.id) !== undefined) {
                    return {
                        ...analyte,
                        is_captured: (analyte.is_captured && analyte.capture === '' ? false : true)
                    }
                }
                else
                    return analyte;
            });

            setAnalytes([...updateAnalytes]);

            let updateSections = sections;
            let updateProfiles = profiles;
            analitosSend.forEach(analito => {
                if (analito.is_exam) {
                    //EXAMENES
                    updateSections.map(section => {
                        if (section.id === analito.id_section) {
                            section.exams.map(exam => {
                                if (exam.id_exam === analito.id_exam && exam.id_work_order_exam === analito.id_work_order_exam) {
                                    let reAnalytes = exam.analytes.map(analyte => {
                                        if (analyte.id_analyte === analito.id) {
                                            let precoded = null;
                                            let number = null;
                                            let text = "";

                                            if (analito.id_type_analyte === 1) {
                                                precoded = analito.capture === '' ? '' : parseInt(analito.capture);
                                            } else if (analito.id_type_analyte === 6) {
                                                text = analito.capture;
                                            } else if (analito.id_type_analyte === 2) {
                                                number = analito.capture === '' ? '' : parseInt(analito.capture);
                                            } else {
                                                number = analito.capture === '' ? '' : parseFloat(analito.capture, analyte.decimals);
                                            }

                                            let captureData = {
                                                "id_user": 0,
                                                "id_precoded_text": precoded,
                                                "number": number,
                                                "text": text,
                                                "id_exam_method": analito.id_app_code_or_method_exam,
                                                "is_interface": false,
                                                "comments": analito.comment
                                            }

                                            analyte.capture = captureData;

                                            let usersCapture = analyte.usersCapture;

                                            let datetime_actual = moment();
                                            let user_capture = {
                                                "id_work_order_exam_analyte": Date.now() + "-" + analito.id,
                                                "username": "",
                                                "full_name": nameUser,
                                                "result_capture": analito.capture,
                                                "date_capture": datetime_actual.format("D/M/YYYY hh:mm a")
                                            };

                                            if (usersCapture === null || usersCapture === undefined) {
                                                usersCapture = [user_capture];
                                            } else {
                                                let validacion = usersCapture[0];
                                                if (validacion.result_capture === user_capture.result_capture) {
                                                    usersCapture = [user_capture, ...usersCapture];
                                                }
                                            }
                                            analyte.usersCapture = usersCapture;

                                            analyte.isCaptured = true;
                                            analyte.is_captured = true;
                                            analyte.required = true;
                                        }
                                        return analyte;
                                    })
                                    exam.analytes = [...reAnalytes];
                                    exam.method_selected = analito.id_app_code_or_method_exam;
                                }
                                return exam;
                            })
                        }
                        return section;
                    })
                } else {
                    //PERFILES
                    updateProfiles.map(perfil => {
                        if (perfil.id_profile === analito.id_profile) {
                            let readyToValidateProfile = true;
                            let readyToReleaseProfile = true;
                            perfil.exams.map(exam => {

                                if (exam.id_exam === analito.id_exam && exam.id_work_order_exam === analito.id_work_order_exam) {
                                    let reAnalytes = exam.analytes.map(analyte => {
                                        if (analito.sub_id !== null && analito.sub_id !== undefined) {
                                            if ((analyte.id_analyte === analito.id) && (analyte.sub_id === analito.sub_id)) {
                                                let precoded = null;
                                                let number = null;
                                                let text = "";

                                                if (analito.id_type_analyte === 1) {
                                                    precoded = analito.capture === '' ? '' : parseInt(analito.capture);
                                                } else if (analito.id_type_analyte === 6) {
                                                    text = analito.capture;
                                                } else if (analito.id_type_analyte === 2) {
                                                    number = analito.capture === '' ? '' : parseInt(analito.capture);
                                                } else {
                                                    number = analito.capture === '' ? '' : parseFloat(analito.capture, analyte.decimals);
                                                }

                                                let captureData = {
                                                    "id_user": 0,
                                                    "id_precoded_text": precoded,
                                                    "number": number,
                                                    "text": text,
                                                    "id_exam_method": analito.id_app_code_or_method_exam,
                                                    "is_interface": false,
                                                    "comments": analito.comment
                                                }
                                                analyte.capture = captureData;

                                                let usersCapture = analyte.usersCapture;

                                                let datetime_actual = moment();
                                                let user_capture = {
                                                    "id_work_order_exam_analyte": Date.now() + "-" + analito.id,
                                                    "username": "",
                                                    "full_name": nameUser,
                                                    "result_capture": analito.capture,
                                                    "date_capture": datetime_actual.format("D/M/YYYY hh:mm a")
                                                };
                                                if (usersCapture === null || usersCapture === undefined) {
                                                    usersCapture = [user_capture];
                                                } else {
                                                    let validacion = usersCapture[0];
                                                    if (validacion.result_capture === user_capture.result_capture) {
                                                        usersCapture = [user_capture, ...usersCapture];
                                                    }
                                                }
                                                analyte.usersCapture = usersCapture;

                                                analyte.isCaptured = true;
                                                analyte.is_captured = true;
                                                analyte.required = true;
                                            }
                                        }
                                        else if (analyte.id_analyte === analito.id) {

                                            let precoded = null;
                                            let number = null;
                                            let text = "";

                                            if (analito.id_type_analyte === 1) {
                                                precoded = analito.capture === '' ? '' : parseInt(analito.capture);
                                            } else if (analito.id_type_analyte === 6) {
                                                text = analito.capture;
                                            } else if (analito.id_type_analyte === 2) {
                                                number = analito.capture === '' ? '' : parseInt(analito.capture);
                                            } else {
                                                number = analito.capture === '' ? '' : parseFloat(analito.capture, analyte.decimals);
                                            }

                                            let captureData = {
                                                "id_user": 0,
                                                "id_precoded_text": precoded,
                                                "number": number,
                                                "text": text,
                                                "id_exam_method": analito.id_app_code_or_method_exam,
                                                "is_interface": false,
                                                "comments": analito.comment
                                            }
                                            analyte.capture = captureData;

                                            let usersCapture = analyte.usersCapture;

                                            let datetime_actual = moment();
                                            let user_capture = {
                                                "id_work_order_exam_analyte": Date.now() + "-" + analito.id,
                                                "username": "",
                                                "full_name": nameUser,
                                                "result_capture": analito.capture,
                                                "date_capture": datetime_actual.format("D/M/YYYY hh:mm a")
                                            };

                                            if (usersCapture === null || usersCapture === undefined) {
                                                usersCapture = [user_capture];
                                            } else {
                                                let validacion = usersCapture[0];
                                                if (validacion.result_capture === user_capture.result_capture) {
                                                    usersCapture = [user_capture, ...usersCapture];
                                                }
                                            }
                                            analyte.usersCapture = usersCapture;

                                            analyte.isCaptured = true;
                                            analyte.is_captured = true;
                                            analyte.required = true;
                                        }
                                        return analyte;
                                    })
                                    exam.analytes = [...reAnalytes];

                                    exam.method_selected = analito.id_app_code_or_method_exam;
                                }

                                exam.analytes !== null && exam.analytes.forEach(element => {
                                    if (element.required) {
                                        if (element.isCaptured === false) {
                                            readyToValidateProfile = false;
                                        }
                                        if (element.userValidate === null) {
                                            readyToReleaseProfile = false;
                                        }
                                    }
                                });

                                return exam;
                            })
                            perfil.readyToValidateProfile = readyToValidateProfile;
                            perfil.readyToReleaseProfile = readyToReleaseProfile;
                        }
                        return perfil;
                    })
                }
            });

            //!SAVE RESULT PRESUNTIVE MEMORY
            const presumtive_results_capture = presumptive.map(item => {
                const newItem = { ...item };
                //!FILTER DELETE
                newItem.presumptives = newItem.presumptives.filter(element => !element.idDelete);
                newItem.presumptives.forEach(element => {
                    //!RECUPERATE VALUE INPUTS SAVE
                    element.id_mic_bacterium = element.id_mic_bacterium1;
                    element.id_mic_stain = element.id_mic_stain1;
                    element.id_mic_stain_result = element.id_mic_stain_result1;
                });
                return newItem;
            });

            setPresumptive([...presumtive_results_capture])
            setSections([...updateSections]);
            setProfiles([...updateProfiles]);
            createSweet("success", "success", "Información guardada correctamente");
            getData();

            // if (_url_helen !== labcen && _url_helen !== demo && _url_helen !== pyrsa && _url_helen !== semlab && _url_helen !== hsjs && _url_helen !== buap && _url_helen !== insan && _url_helen !== qfb && _url_helen !== cedimi) {
            //     window.location.reload();
            // }
            if (shouldReload) {
                window.location.reload();
            } else {
                setShowReloadLoader(false);
            }

        }
        else if (respuesta.code === 401) validarSesion(history, respuesta.code, saveAllAnalytes);

        else if (respuesta.code === 500) createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");

        else createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);

        toggleLoadingButton(false);
    }
    const releaseExam = async (id_work_order_exam, id_exam) => {

        if (!beginProcessingValidation()) return;

        setLoadingReleaseExamCapture(prev => ({ ...prev, [id_work_order_exam]: true }));

        try {

            let nuevas_secciones = JSON.parse(userSections);
            let filtro_secciones = JSON.parse(userFilterSections);
            nuevas_secciones = nuevas_secciones.filter(x => {
                if (filtro_secciones.find(y => y.id_section === x)) {
                    return x
                }
            })

            let payload = {
                "id_work_order_exam": id_work_order_exam,
                "id_exam": id_exam,
                "sections_array": nuevas_secciones,

            }

            let data = JSON.stringify(payload);
            let requestOptions = {
                method: 'POST',
                body: data
            };

            const respuesta = await sendRequest(requestOptions, 'Exam/ReleaseExam');

            if (respuesta.code === 200) {
                // //console.log("Ëxito");
                let updateSections = sections;
                let updateProfiles = profiles;

                // let validacion_impresion = true;
                let anyReleased = false;
                let allReleased = true;



                updateSections.map(section => {
                    let examenes = section.exams.map(exam => {
                        if (exam.id_work_order_exam === id_work_order_exam && exam.id_exam === id_exam) {
                            exam.isRelease = true;
                            let userData = {
                                "id_user": 0,
                                "id_external": "",
                                "is_admin": false,
                                "is_dfa": false,
                                "username": nameUser,
                                "name": "",
                                "paternal_surname": "",
                                "maternal_surname": "",
                                "email": null,
                                "id_job": null,
                                "job": null,
                                "card_code": null,
                            }
                            exam.user = userData;
                            exam.release_date = moment().format("D/M/YYYY hh:mm a");

                            let analyteUpdate = exam.analytes.map(analyte => {
                                analyte.userValidate = {
                                    "id_work_order_exam_analyte": moment() + analyte.id_analyte,
                                    "full_name": nameUser,
                                    "result_capture": "0",
                                    "date_capture": moment().format("D/M/YYYY hh:mm a")
                                }
                                return analyte;
                            })

                            exam.analytes = [...analyteUpdate];
                        }
                        if (exam.isRelease) {
                            anyReleased = true;
                        } else {
                            allReleased = false;
                        }

                        return exam;
                    })
                    section.exams = [...examenes];
                    return section;
                });

                updateProfiles.map(perfil => {
                    let examenes = perfil.exams.map(exam => {
                        if (exam.id_work_order_exam === id_work_order_exam && exam.id_exam === id_exam) {
                            exam.isRelease = true;
                            let userData = {
                                "id_user": 0,
                                "id_external": "",
                                "is_admin": false,
                                "is_dfa": false,
                                "username": nameUser,
                                "name": "",
                                "paternal_surname": "",
                                "maternal_surname": "",
                                "email": null,
                                "id_job": null,
                                "job": null,
                                "card_code": null,
                            }
                            exam.user = userData;
                            exam.release_date = moment().format("D/M/YYYY hh:mm a");

                            let analyteUpdate = exam.analytes.map(analyte => {
                                analyte.userValidate = {
                                    "id_work_order_exam_analyte": moment() + analyte.id_analyte,
                                    "full_name": nameUser,
                                    "result_capture": "0",
                                    "date_capture": moment().format("D/M/YYYY hh:mm a")
                                }
                                return analyte;
                            })

                            exam.analytes = [...analyteUpdate];
                        }
                        if (exam.isRelease) {
                            anyReleased = true;
                        } else {
                            allReleased = false;
                        }

                        return exam;
                    })
                    perfil.exams = [...examenes];
                    return perfil;
                })

                setListCurves(prevList => {
                    return prevList.map(exam => {
                        if (exam.id_exam === id_exam && exam.id_work_order_exam === id_work_order_exam) {
                            return {
                                ...exam,
                                curves: exam.curves.map(curve => ({
                                    ...curve,
                                    released_at: moment().toISOString(),
                                    name_user_release: nameUser,
                                    id_user_release: true,
                                }))
                            };
                        }
                        return exam;
                    });
                });

                // //console.log(updateSections);
                // //console.log(updateProfiles);
                setSections([...updateSections]);
                setProfiles([...updateProfiles]);
                setPrintAvailable(anyReleased);
                setResultsPartial(anyReleased);
                setDobleValidacion(true);




                // setPrintAvailable(respuesta.data);
                // setDobleValidacion(respuesta.data);
                // await getData();
                //previewWorkOrder();
                createSweet("success", "success", "Se ha liberado el examen");
            }
            else if (respuesta.code === 401) {

                validarSesion(history, respuesta.code, releaseExam);
            }
            else if (respuesta.code === 500) {

                createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
            }
            else {

                createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
            }

        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Captura de resultados", "Ocurrió un error inesperado");

        } finally {
            setLoadingReleaseExamCapture(prev => ({
                ...prev,
                [id_work_order_exam]: false
            }));

            endProcessingValidation();
        }
        // else {
        //     createSweet("error", "error", "Hubo un error!");
        //     validarSesion(history, respuesta.code, releaseExam);
        // }
    }

    const releaseAll = async () => {

        if (!beginProcessingValidation()) return;

        setLoadingRelease(true);
        try {


            let id_work_order = workOrderId;
            let nuevas_secciones = JSON.parse(userSections);
            let filtro_secciones = JSON.parse(userFilterSections);
            nuevas_secciones = nuevas_secciones.filter(x => {
                if (filtro_secciones.find(y => y.id_section === x)) {
                    return x
                }
            })

            let payload = {
                "sections": nuevas_secciones,
                "nim": nim,
                "id_work_order": id_work_order,

            }
            let data = JSON.stringify(payload);
            let requestOptions = {
                method: 'POST',
                body: data
            };

            const respuesta = await sendRequest(requestOptions, 'Exam/ReleaseAll');

            if (respuesta.code === 200) {
                let liberados = respuesta.data.list_id_work_order_exams;

                let updateSections = JSON.parse(JSON.stringify(sections));
                let updateProfiles = JSON.parse(JSON.stringify(profiles));

                let validacion_impresion = true;
                updateSections.map(section => {
                    // //console.log(section);
                    let examenes = section.exams.map(exam => {
                        if (liberados.find(x => x === exam.id_work_order_exam) !== undefined) {
                            exam.isRelease = true;
                            let userData = {
                                "id_user": 0,
                                "id_external": "",
                                "is_admin": false,
                                "is_dfa": false,
                                "username": nameUser,
                                "name": "",
                                "paternal_surname": "",
                                "maternal_surname": "",
                                "email": null,
                                "id_job": null,
                                "job": null,
                                "card_code": null,
                            }
                            exam.user = userData;
                            exam.release_date = moment().format("D/M/YYYY hh:mm a");

                            let analyteUpdate = exam.analytes.map(analyte => {
                                analyte.userValidate = {
                                    "id_work_order_exam_analyte": moment() + analyte.id_analyte,
                                    "full_name": nameUser,
                                    "result_capture": "0",
                                    "date_capture": moment().format("D/M/YYYY hh:mm a")
                                }
                                return analyte;
                            })

                            exam.analytes = [...analyteUpdate];
                        }
                        if (!exam.isRelease) {
                            validacion_impresion = false;
                        }
                        return exam;
                    })
                    section.exams = [...examenes];
                    return section;
                });

                updateProfiles.map(perfil => {
                    let examenes = perfil.exams.map(exam => {
                        if (liberados.find(x => x === exam.id_work_order_exam) !== undefined) {
                            exam.isRelease = true;
                            let userData = {
                                "id_user": 0,
                                "id_external": "",
                                "is_admin": false,
                                "is_dfa": false,
                                "username": nameUser,
                                "name": "",
                                "paternal_surname": "",
                                "maternal_surname": "",
                                "email": null,
                                "id_job": null,
                                "job": null,
                                "card_code": null,
                            }
                            exam.user = userData;
                            exam.release_date = moment().format("D/M/YYYY hh:mm a");

                            let analyteUpdate = exam.analytes.map(analyte => {
                                analyte.userValidate = {
                                    "id_work_order_exam_analyte": moment() + analyte.id_analyte,
                                    "full_name": nameUser,
                                    "result_capture": "0",
                                    "date_capture": moment().format("D/M/YYYY hh:mm a")
                                }
                                return analyte;
                            })

                            exam.analytes = [...analyteUpdate];
                        }
                        if (!exam.isRelease) {
                            validacion_impresion = false;
                        }
                        return exam;
                    })
                    perfil.exams = [...examenes];
                    return perfil;
                })
                // //console.log(updateSections);
                // //console.log(updateProfiles);
                setSections([...updateSections]);
                setProfiles([...updateProfiles]);
                const anyReleasedSections = updateSections.some(sec =>
                    sec.exams.some(ex => ex.isRelease)
                );

                const anyReleasedProfiles = updateProfiles.some(per =>
                    per.exams.some(ex => ex.isRelease)
                );

                const anyReleased = anyReleasedSections || anyReleasedProfiles;
                setResultsPartial(anyReleased);
                setDobleValidacion(anyReleased);
                setPrintAvailable(anyReleased);

                // setPrintAvailable(respuesta.data.release);
                //previewWorkOrder();
                // await getData();
                createSweet("success", "success", "Se ha liberado el examen");
            }
            else if (respuesta.code === 401) {
                validarSesion(history, respuesta.code, releaseExam);
            }
            else if (respuesta.code === 500) {
                createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
            }
            else {
                createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
            }
            setLoadingRelease(false);
            closeDialogRelease();
        } catch (error) {
            console.error(error);

            createSweet(
                "error",
                "error",
                "Captura de resultados",
                "Ocurrió un error inesperado"
            );

        } finally {
            setLoadingRelease(false);
            endProcessingValidation();
        }
    }

    const validateAnalyte = async (id_work_order_exam, id_exam, id_analyte, sub_id, analito) => {
        let payload = {
            "id_work_order_exam": id_work_order_exam,
            "id_exam": id_exam,
            "id_analyte": id_analyte,
            "sub_id": sub_id !== null ? sub_id : ""
        }
        let data = JSON.stringify(payload);
        let requestOptions = {
            method: 'POST',
            body: data
        };
        const respuesta = await sendRequest(requestOptions, 'Exam/ValidateAnalyte');
        if (respuesta.code === 200) {
            if (analito.is_exam) {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === analito.id_section) {
                        section.exams.map(exam => {
                            if (exam.id_exam === analito.id_exam && exam.id_work_order_exam === analito.id_work_order_exam) {
                                let nuevos_analitos = exam.analytes.map(analyte => {
                                    if (analyte.id_analyte === analito.id) {
                                        let userValidate = {
                                            "id_work_order_exam_analyte": Date.now() + "validate" + id_analyte,
                                            "full_name": nameUser,
                                            "result_capture": "0",
                                            "date_capture": moment().format("D/M/YYYY hh:mm a")
                                        }
                                        analyte.userValidate = userValidate;
                                    }
                                    return analyte;
                                })
                                exam.analytes = [...nuevos_analitos];
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);

            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === analito.id_profile) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === analito.id_exam && exam.id_work_order_exam === analito.id_work_order_exam) {
                                let nuevos_analitos = exam.analytes.map(analyte => {
                                    if (analyte.id_analyte === analito.id) {
                                        let userValidate = {
                                            "id_work_order_exam_analyte": Date.now() + "validate" + id_analyte,
                                            "full_name": nameUser,
                                            "result_capture": "0",
                                            "date_capture": moment().format("D/M/YYYY hh:mm a")
                                        }
                                        analyte.userValidate = userValidate;
                                    }
                                    return analyte;
                                })
                                exam.analytes = [...nuevos_analitos];
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }

            createSweet("success", "success", "Se ha validado el resultado");
        }
        else if (respuesta.code === 401) {

            validarSesion(history, respuesta.code, validateAnalyte);
        }
        else if (respuesta.code === 500) {

            createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
        }
        else {

            createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
        }
        //TODO:DESCOMENTRAR

        // else {
        //     createSweet("error", "error", "Hubo un error!");
        //     validarSesion(history, respuesta.code, releaseExam);
        // }
    }

    const validateExam = async (id_work_order_exam, id_exam, typeArray, sectionProfileId) => {

        if (!beginProcessingValidation()) return;

        setLoadingValidateCapture(prev => ({
            ...prev,
            [id_work_order_exam]: true
        }));

        try {
            let payload = {
                "id_work_order_exam": id_work_order_exam,
                "id_exam": id_exam,
            }
            let data = JSON.stringify(payload);
            let requestOptions = {
                method: 'POST',
                body: data
            };

            const respuesta = await sendRequest(requestOptions, 'Exam/ValidateExam');
            // console.log(respuesta);
            if (respuesta.code === 200) {
                if (typeArray === "section") {
                    let updateSections = sections;
                    updateSections.map(section => {
                        if (section.id === sectionProfileId) {
                            section.exams.map(exam => {
                                if (exam.id_exam === id_exam && exam.id_work_order_exam === id_work_order_exam) {

                                    let nuevos_analitos = exam.analytes.map(analyte => {

                                        if (analyte.isCaptured) {

                                            let userValidate = {
                                                id_work_order_exam_analyte: Date.now() + "validate" + analyte.id_analyte,
                                                full_name: nameUser,
                                                result_capture: "0",
                                                date_capture: moment().format("D/M/YYYY hh:mm a")
                                            };

                                            analyte.userValidate = userValidate;
                                        }
                                        else {
                                            analyte.userValidate = {
                                                id_estatus_exam: 4,
                                            };
                                        }

                                        // <-- Agrega esto
                                        if (analyte.print_graph && analyte.capture) {
                                            analyte.capture.print_chart = true;
                                        }

                                        return analyte;
                                    });
                                    exam.analytes = [...nuevos_analitos];
                                    exam.id_estatus_exam = 4;
                                }
                                return section;
                            })
                        }
                        return section;
                    })
                    setSections([...updateSections]);
                    setMicroBacteriums(prev =>
                        prev.map(micro => {
                            if (micro.id_work_order_exam === id_work_order_exam) {
                                return {
                                    ...micro,
                                    userValidate: true
                                };
                            }
                            return micro;
                        })
                    );

                } else {
                    let updateProfiles = profiles;
                    updateProfiles.map(perfil => {
                        if (perfil.id_profile === sectionProfileId) {
                            perfil.exams.map(exam => {
                                if (exam.id_exam === id_exam && exam.id_work_order_exam === id_work_order_exam) {
                                    let nuevos_analitos = exam.analytes.map(analyte => {
                                        if (analyte.isCaptured) {
                                            let userValidate = {
                                                "id_work_order_exam_analyte": Date.now() + "validate" + analyte.id_analyte,
                                                "full_name": nameUser,
                                                "result_capture": "0",
                                                "date_capture": moment().format("D/M/YYYY hh:mm a")
                                            }
                                            analyte.userValidate = userValidate;
                                        }
                                        else {

                                            let userValidate = {

                                                "id_estatus_exam": 4,
                                            }
                                            analyte.userValidate = userValidate;

                                        }

                                        if (analyte.print_graph && analyte.capture) {
                                            analyte.capture.print_chart = true;
                                        }
                                        return analyte;
                                    })
                                    exam.analytes = [...nuevos_analitos];
                                    exam.id_estatus_exam = 4;
                                    let readyToValidateProfile = false;
                                    readyToValidateProfile = perfil.exams.some(x => x.id_estatus_exam !== 4);
                                    perfil.readyToValidateProfile = readyToValidateProfile;
                                }
                                return exam;
                            })
                        }
                        return perfil;
                    })
                    setProfiles([...updateProfiles]);
                }

                setListCurves(prevList => {
                    return prevList.map(exam => {
                        if (exam.id_exam === id_exam && exam.id_work_order_exam === id_work_order_exam) {
                            return {
                                ...exam,
                                curves: exam.curves.map(curve => ({
                                    ...curve,
                                    id_user_validate: true,
                                    name_user_validate: nameUser,
                                    validated_at: new Date().toISOString(),
                                }))
                            };
                        }
                        return exam;
                    });
                });

                //previewWorkOrder();

                let bacterias = microBacteriums.filter(x => x.id_work_order_exam === id_work_order_exam);
                bacterias.forEach(async (element) => {
                    // await validateBacterium(id_work_order_exam, id_exam, element.id_bacterium, "section");
                });
                createSweet("success", "success", "Se ha validado la prueba correctamente");
            }
            else if (respuesta.code === 401) {

                validarSesion(history, respuesta.code, validateAnalyte);
            }
            else if (respuesta.code === 500) {

                createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
            }
            else {

                createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
            }
        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Captura de resultados", "Ocurrió un error inesperado");
        } finally {
            setLoadingValidateCapture(prev => ({
                ...prev,
                [id_work_order_exam]: false
            }));

            endProcessingValidation();

        };
    }

    const validateProfile = async (id_profile, id_work_order, id_work_order_profile) => {

        if (!beginProcessingValidation()) return;

        setLoadingValidateProfileC(true);
        try {



            let nuevas_secciones = JSON.parse(userSections);
            let filtro_secciones = JSON.parse(userFilterSections);
            nuevas_secciones = nuevas_secciones.filter(x => {
                if (filtro_secciones.find(y => y.id_section === x)) {
                    return x
                }
            })


            let payload = {
                "id_work_order_exam": id_work_order_profile,
                "id_exam": id_profile,
                "sections_array": nuevas_secciones,

            }
            let data = JSON.stringify(payload);
            let requestOptions = {
                method: 'POST',
                body: data
            };

            const respuesta = await sendRequest(requestOptions, 'Exam/ValidateProfile');
            if (respuesta.code === 200) {

                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_work_order_profile === id_work_order_profile) {
                        let readyToValidateProfile = true;
                        let readyToReleaseProfile = true;
                        perfil.exams.map(exam => {
                            let nuevos_analitos = exam.analytes.map(analyte => {
                                if (analyte.isCaptured) {
                                    let userValidate = {
                                        "id_work_order_exam_analyte": Date.now() + "validate" + analyte.id_analyte,
                                        "full_name": nameUser,
                                        "result_capture": "0",
                                        "date_capture": moment().format("D/M/YYYY hh:mm a")
                                    }
                                    analyte.userValidate = userValidate;
                                }

                                if (analyte.print_graph && analyte.capture) {
                                    analyte.capture.print_chart = true;
                                }

                                return analyte;
                            })
                            exam.analytes = [...nuevos_analitos];
                            exam.id_estatus_exam = 4;
                            exam.analytes !== null && exam.analytes.forEach(element => {
                                if (element.required) {
                                    if (element.isCaptured === false) {
                                        readyToValidateProfile = false;
                                    }
                                    if (element.userValidate === null) {
                                        readyToReleaseProfile = false;
                                    }
                                }
                            });
                            return exam;
                        })
                        perfil.readyToValidateProfile = readyToValidateProfile;
                        perfil.readyToReleaseProfile = readyToReleaseProfile;
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
                createSweet("success", "success", "Se ha validado el perfil correctamente");
            }
            else if (respuesta.code === 401) {

                validarSesion(history, respuesta.code, validateProfile);
            }
            else if (respuesta.code === 500) {

                createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
            }
            else {

                createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
            }
        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Captura de resultados", "Ocurrió un error inesperado");

        } finally {
            setLoadingValidateProfileC(false);
            endProcessingValidation();
        }

    }

    const calculateAge = (birthday) => {
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        var anios = Math.abs(ageDate.getUTCFullYear() - 1970);


        return anios;
    }

    const calculateAgeMonths = (birthday) => {
        var a = moment();
        var b = moment(birthday, 'YYYY-MM-DD');
        var age = moment.duration(a.diff(b));
        var months = age.months();
        var days = age.days();
        let anios = months + " mes(es)" + " y " + days + " día(s)";
        return anios;
    }

    const printWorkOrder = async (is_printed) => {

        let payload = {
            "nim": nim,
            "password": "",
            "type": "NP"
        }
        let data = JSON.stringify(payload);
        let token = localStorage.getItem("token");

        let alter_url = "";

        if (is_printed) {
            alter_url = "?is_printed=" + is_printed;
        }

        await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResults" + alter_url, {
            method: 'POST',
            body: data,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se ha podido descargar el pdf");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "hoja_resultados_" + nim + ".pdf");
                document.body.appendChild(link);
                link.click();
                createSweet("success", "success", "Descarga completa");
            });

    }

    const previewWorkOrder = async () => {

        setworkMedicalOrderPDFLoading(true)
        setLoadingPdf(true);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + `/api/PrintResult/PreviewAlt?nim=${nim}&type=NP&is_micro_sanitary=${false}&is_preview=true`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) return;
                return response.json();
            })
            .then(async data => {
                // console.log(data);
                // console.log(nim);
                await fetch(`${ConfigServer.serverUrl}/api/PrintResult/GetFile/${data.watermark}`, {
                    method: 'GET',
                    headers: new Headers({
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    })
                })
                    .then(response => {
                        if (response.status !== 200) {
                            return;
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        setworkMedicalOrderPDFLoading(false);
                        setLoadingPdf(false);
                        setworkMedicalOrderPDF(url);
                        setworkMedicalOrderPDFDownload(`${ConfigServer.serverUrl}/api/PrintResult/DownloadFile/${nim}/${data.raw}?jwt=${token}`);
                    });
            });
    }

    const previewProgressWorkOrder = async (_valid) => {

        setworkMedicalOrderPDFLoading(true)
        let token = localStorage.getItem("token");

        if (_valid === undefined) {

        }

        await fetch(ConfigServer.serverUrl + `/api/PrintResult/ProgressView?nim=${nim}&type=NP&is_micro_sanitary=false&is_preview=true`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) return;
                return response.json();
            })
            .then(async data => {
                // console.log(data);
                // console.log(nim);
                await fetch(`${ConfigServer.serverUrl}/api/PrintResult/GetFile/${data.watermark}`, {
                    method: 'GET',
                    headers: new Headers({
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    })
                })
                    .then(response => {
                        if (response.status !== 200) {
                            return;
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        setworkMedicalOrderPDFLoading(false);
                        setworkMedicalOrderPDF(url);
                        setworkMedicalOrderPDFDownload(`${ConfigServer.serverUrl}/api/PrintResult/DownloadFile/${nim}/${data.raw}?jwt=${token}`);
                    });
            });
    }

    const sendResultForEmail = async (sendDoctor) => {

        let payload = {
            "nim": nim,
            "password": "",
            "type": "NP",
            "doctor": sendDoctor
        }

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(payload)
        };

        const respuesta = await sendRequest(requestOptions, "PrintResult/SendResultForEmail");

        if (respuesta.code === 200) {
            createSweet("create", "success", "Exito!", "Los resultados se han enviado correctamente");
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, sendResultForEmail);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Resultados", respuesta.data.msg);
        }
        else {
            createSweet("error", "warning", "Resultados", respuesta.data.msg);
        }
    }

    useEffect(() => {
        getFuncionesFormula().then(resp => {
            getData(resp);
        });
        backNextState();
    }, [])

    const backNextState = () => {
        var nims = JSON.parse(localStorage.getItem("current_work_orders"));
        if (nims == null) nims = [];
        var idx = nims.indexOf(nim);
        setBackNim((idx <= 0) ? null : nims[idx - 1]);
        setNextNim((idx == (nims.length - 1)) ? null : nims[idx + 1])
    }

    const gotoNim = (goNim, micro) => {
        if (goNim != null) {
            const url = micro
                ? `/captura-resultados-sanitaria/${goNim}`
                : `/captura-resultados/${goNim}`;

            if (window.location.pathname !== url) {
                window.location.href = url;
            }
        }
    };



    const handleEditCommentsPrintResults = (e) => {
        setCommentsPrintResult(e.target.value);
    }

    const saveCommentsWorkOrder = async () => {

        let formValues = {
            'id_work_order': workOrderId,
            'comment': commentsPrintResult
        };

        if (workOrderId != 0) {

            let requestOptions = {
                method: 'PUT',
                body: JSON.stringify(formValues)
            };

            const respuesta = await sendRequest(requestOptions, "WorkOrder/SaveGlobalCommentsWorkOrder");

            if (respuesta.code === 200) {
                createSweet("create", "success", "Exito!", "Comentarios actualizados");
            }
            else if (respuesta.code === 401) {
                validarSesion(history, respuesta.code, saveCommentsWorkOrder);
            }
            else if (respuesta.code === 500) {
                createSweet("error", "error", "Convenios", "Ocurrio un error en el servidor");
            }
            else {
                createSweet("error", "warning", "Convenios", respuesta.data.msg);
            }

        }
    }

    const deleteCommentsWorkOrder = async () => {

        if (workOrderId !== 0) {

            const requestOptions = {
                method: "PUT",
                body: JSON.stringify({ id_work_order: workOrderId })
            };

            const respuesta = await sendRequest(requestOptions, "WorkOrder/DeleteGlobalCommentsWorkOrder");

            if (respuesta.code === 200) {
                setCommentsPrintResult("");

                createSweet("create", "success", "Éxito!", "Comentarios eliminados correctamente");
            }
            else if (respuesta.code === 401) {
                // validarSesion(history, respuesta.code, deleteCommentsWorkOrder);
            }
            else if (respuesta.code === 500) {
                createSweet("error", "error", "Comentarios", "Ocurrió un error en el servidor");
            }
            else {
                createSweet("error", "warning", "Comentarios", respuesta.data?.msg || "No fue posible eliminar los comentarios");
            }
        }
    };

    //#region TYPE BACTERIUM
    // ?  VALIDATE TYPE BACTERIUM
    const handleTypeBacterium = (_type, _idTemp, _id_work_order_exam, _id_mic_bacterium) => {
        console.log("🚀 ~ handleTypeBacterium ~ _id_mic_bacterium:", _id_mic_bacterium)
        console.log("🚀 ~ handleTypeBacterium ~ _id_work_order_exam:", _id_work_order_exam)
        console.log("🚀 ~ handleTypeBacterium ~ _idTemp:", _idTemp)
        console.log("🚀 ~ recalculateComplex ~ _type:", _type)
        //        let _valid = _newArray.find(x => x.id_temp  === _id && x.id_work_order_exam === _idExam);

        let _newArray = microBacteriums
        console.log("🚀 ~ recalculateComplex ~ _newArray:", _newArray)
        let _valid = _newArray.find(x => x.id_temp === _idTemp && x.id_work_order_exam === _id_work_order_exam);
        console.log("🚀 ~ recalculateComplex ~ _valid:", _valid)

        if (_valid !== undefined) {
            let _validate = false;

            if (_valid.id_work_order_exam === _id_work_order_exam) {
                _validate = true;
            }

            if (_validate) {
                _valid.type_bacterium = _type
                switch (_type) {
                    case 1:
                        _valid.view1 = true
                        _valid.view2 = false
                        _valid.view3 = false
                        _valid.bacterium_texts = []
                        break;
                    case 2:
                        _valid.view1 = false
                        _valid.view2 = true
                        _valid.view3 = false
                        handleChangeComments(_type, _idTemp, _id_work_order_exam, _id_mic_bacterium)
                        _valid.antibiotics = []
                        break;
                    case 3:
                        _valid.view1 = false
                        _valid.view2 = false
                        _valid.view3 = true
                        handleChangeComments(_type, _idTemp, _id_work_order_exam, _id_mic_bacterium)
                        _valid.antibiotics = []
                        break;
                    default:
                        break;
                }
            }
            if (_newArray?.length > 0)
                setMicroBacteriums([..._newArray]);
        }
    }

    // ! TYPE BACTERIUM 1 ----------------

    // ?  NEW ANTIBIOGRAM
    const addMicroAislado = (_id_work_order_exam, type) => {
        let bacters = microBacteriums;

        let nuevo = {
            id_temp: Date.now(),
            userValidate: null,
            id_work_order_exam: _id_work_order_exam,
            id_mic_stain_gram: "",
            id_mic_bacterium: "",
            quantity_number: "",
            id_bacterium_count_text: null,
            comment_resistance_mechanism: "",
            type_bacterium: null,
            id_mic_antibiogram: null,
            ids_resistance_mechanisms: [],
            bacterium_texts: [],
            antibiotics: [],
            view1: false,
            view2: false,
            view3: false,
            released_at: "",
            released_by: "",
            validated_at: "",
            validated_by: "",
        };

        setMicroBacteriums([...bacters, nuevo]);
        if (type === "section") {
            let secciones = sections.map(x => {
                let exams2 = x.exams.map(xx => {
                    if (xx.id_work_order_exam === _id_work_order_exam) {
                        if (xx.bacteriums !== undefined && xx.bacteriums !== null) {
                            xx.bacteriums = [...xx.bacteriums, nuevo];
                        } else {
                            xx.bacteriums = [nuevo];
                        }
                    }
                    return xx;
                })
                x.exams = [...exams2]
                return x;
            });
            setSections([...secciones])
        } else if (type === "profile") {
            profiles.map(x => {
                let exams2 = x.exams.map(xx => {
                    if (xx.id_work_order_exam === _id_work_order_exam) {
                        if (xx.bacteriums !== undefined && xx.bacteriums !== null) {
                            xx.bacteriums = [...xx.bacteriums, nuevo];
                        } else {
                            xx.bacteriums = [nuevo];
                        }
                    }
                    return xx;
                })
                x.exams = [...exams2]
                return x;
            });


        } else {
        }
    }

    // ? DELETE BACTERIUM 1
    const removeBacterium1 = (_id_work_order_exam, _id, _id_mic_bacterium) => {

        const bacterium = microBacteriums.find(_x =>
            _x?.id_work_order_exam === _id_work_order_exam &&
            _x?.id_temp === _id
        );

        if (!bacterium) return;

        const handleDelete = async () => {
            try {

                let requestOptions = {
                    method: 'DELETE'
                };

                const respuesta = await sendRequest(
                    requestOptions,
                    `Bacterium/DeleteBacteriumInCapture/${_id_work_order_exam}/${_id_mic_bacterium.value}`
                );

                if (respuesta !== null) {
                    setMicroBacteriums(prev => prev.filter(b => b.id_temp !== _id));
                    createSweet("delete", "success", "Microorganismo eliminado");
                } else {
                    createSweet("error", "error", "No se pudo eliminar");
                }

            } catch (error) {
                console.error(error);
                createSweet("error", "error", "Error al eliminar");
            }
        };

        sweetDeleteBacterium1(
            "Microorganismo",
            `Esta seguro de eliminar el microorganismo ${_id_mic_bacterium.label}, se perderan todos los datos`,
            "error",
            true,
            _id,
            handleDelete
        );
    };
    // !TYPE BACTERIUM 2 ----------------

    // ? NEW BACTERIUM TEXTS
    const handleChangeComments = (_type, _id, _idExam, _id_mic_bacterium) => {

        let _newArray = microBacteriums;
        let _valid = _newArray.find(x => x.id_temp === _id);

        if (_valid !== undefined) {
            let _validate = false;

            if (_id_mic_bacterium === null || _id_mic_bacterium === undefined || _id_mic_bacterium === "") {
                if (_valid.id_temp === _id) {
                    _validate = true;
                }
            } else {
                if (_valid.id_work_order_exam === _idExam) {
                    _validate = true;
                }
            }

            if (_validate) {

                let newEntry = {
                    id: Date.now(),
                    id_work_order_exam_bacterium_text: null,
                    text: ""
                };

                if (!Array.isArray(_valid.bacterium_texts)) {
                    _valid.bacterium_texts = [];
                }
                _valid.bacterium_texts.push(newEntry);

                if (_newArray.length > 0) {
                    setMicroBacteriums([..._newArray]);
                }
            }
        }
    };


    // ? DELETE BACTERIUM 2
    const removeBacteriumAntibitic = async (_id_work_order_exam, _id, _id_mic_bacterium, _i) => {
        let _filter = microBacteriums.filter(b => {
            return b.id_work_order_exam === _id_work_order_exam && b.id_temp === _i;
        });

        if (_filter.length > 0) {
            let _type = _filter[0].bacterium_texts;

            const _update_text = _type.filter(_find => {
                if (_find?.id === _id) {

                    if (_find?.id_work_order_exam_bacterium_text === null || _find?.id_work_order_exam_bacterium_text === "") {
                        return false;
                    } else {

                        sweetDeleteBacterium1(
                            "Antibiotico",
                            `Esta seguro de eliminar el antibiotico del microorganismo ${_id_mic_bacterium.label} , se perderan todos los datos `,
                            "error",
                            true,
                            _find?.id,
                            async (id) => {
                                setMicroBacteriums(prev => {
                                    return prev.map(_search => {
                                        if (_search?.id_temp === _i) {
                                            return {
                                                ..._search,
                                                bacterium_texts: _search?.bacterium_texts.filter(text => text.id !== id),
                                            };
                                        }
                                        return _search;
                                    });
                                });
                            }
                        );
                    }
                }
                return true;
            });

            if (_update_text.length !== _type.length) {
                setMicroBacteriums(prev => {
                    return prev.map(_update => {
                        if (_update?.id_temp === _i) {
                            return {
                                ..._update,
                                bacterium_texts: _update_text
                            };
                        }
                        return _update;
                    });
                });
            }
        }
    };



    // * VALIDATE BACTERIUM -------------------------


    const ValidateBacterium = async (_id_work_order_exam, _id, _id_mic_bacterium, _type, _examId, _sectionProfileId, _type_array, _name_bacterium) => {

        const response = await validateBacterium({
            id_work_order_exam: _id_work_order_exam,
            id_mic_bacterium: _id_mic_bacterium.value,
        });

        if (response.code === 200) {
            createSweett("Validación", `Se ha validado correctamente el microorganismo ${_name_bacterium.label} `, "success");
            const updatedMicroBacteriums = microBacteriums.map(_x => {
                if (_x?.id_work_order_exam === _id_work_order_exam && _x?.id_temp === _id) {
                    _x.validated_by = nameUser
                    _x.validated_at = moment().format("D/M/YYYY hh:mm a")
                }
                return _x;
            });
            setMicroBacteriums(updatedMicroBacteriums);
        }
        else createSweet("warning", "warning", "Bacterias!", response?.msg);
    }

    const UnValidateBacterium = async (_id_work_order_exam, _id, _id_mic_bacterium, _type, _examId, _sectionProfileId, _type_array) => {

        const response = await unValidateBacterium({
            id_work_order_exam: _id_work_order_exam,
            id_mic_bacterium: _id_mic_bacterium.value,
        });

        if (response.code === 200) {
            createSweet("success", "success", "Validación", "Se ha desvalidado correctamente")
            const updatedMicroBacteriums = microBacteriums.map(_x => {
                if (_x?.id_work_order_exam === _id_work_order_exam && _x?.id_temp === _id) {
                    _x.validated_by = ""
                    _x.validated_at = ""

                }
                return _x;
            });
            setMicroBacteriums(updatedMicroBacteriums);
        }
        else createSweet("warning", "warning", "Bacterias!", response?.msg);
    }



    const handleFullUnvalidate = async (_id_work_order_exam, _id, _id_mic_bacterium) => {

        try {
            await unreleaseBacterium({
                id_work_order_exam: _id_work_order_exam,
                id_mic_bacterium: _id_mic_bacterium.value,
            });

            await unValidateBacterium({
                id_work_order_exam: _id_work_order_exam,
                id_mic_bacterium: _id_mic_bacterium.value,
            });

            const updated = microBacteriums.map(_x => {
                if (_x.id_work_order_exam === _id_work_order_exam && _x.id_temp === _id) {
                    return {
                        ..._x,
                        validated_at: "",
                        validated_by: "",
                        released_at: "",
                        released_by: ""
                    };
                }
                return _x;
            });

            setMicroBacteriums(updated);

            createSweet("success", "success", "Listo", "Se desvalidó completamente");

        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Error", "No se pudo desvalidar");
        }
    };

    const ReleaseBacterium = async (_id_work_order_exam, _id, _id_mic_bacterium, _type, _examId, _sectionProfileId, _type_array, _name_bacterium) => {

        const response = await releaseBacterium({
            id_work_order_exam: _id_work_order_exam,
            id_mic_bacterium: _id_mic_bacterium.value,
        });

        if (response.code === 200) {
            createSweett("Liberación", `Se ha liberado correctamente el microorganismo ${_name_bacterium.label} `, "success");
            const updatedMicroBacteriums = microBacteriums.map(_x => {
                if (_x?.id_work_order_exam === _id_work_order_exam && _x?.id_temp === _id) {
                    _x.released_by = nameUser
                    _x.released_at = moment().format("D/M/YYYY hh:mm a")
                }
                return _x;
            });
            setMicroBacteriums(updatedMicroBacteriums);
        }
        else createSweet("warning", "warning", "Bacterias!", response?.msg);
    }

    const UnReleaseBacterium = async (_id_work_order_exam, _id, _id_mic_bacterium, _type, _examId, _sectionProfileId, _type_array) => {

        const response = await unreleaseBacterium({
            id_work_order_exam: _id_work_order_exam,
            id_mic_bacterium: _id_mic_bacterium.value,
        });

        if (response.code === 200) {
            createSweet("success", "success", "Desliberación", "Se ha desliberado correctamente")
            const updatedMicroBacteriums = microBacteriums.map(_x => {
                if (_x?.id_work_order_exam === _id_work_order_exam && _x?.id_temp === _id) {
                    _x.released_by = ""
                    _x.released_at = ""
                }
                return _x;
            });
            setMicroBacteriums(updatedMicroBacteriums);
        }
        else createSweet("warning", "warning", "Bacterias!", response?.msg);
    }

    // * END VALIDATE BACTERIUM -------------------------


    //#endregion

    //!NUEVO
    const removeValidationFromExamOrProfile = async (id_work_order_exam) => {

        if (!beginProcessingValidation()) return;
        setLoadingRemoveCapture(prev => ({
            ...prev,
            [id_work_order_exam]: true
        }));

        try {
            let requestOptions = {
                method: 'GET',
            };

            const respuesta = await sendRequest(requestOptions, "ProcessExam/RemoveValidationFromExamOrProfile/" + id_work_order_exam);
            // console.log('RESPUESTA: ', respuesta);

            if (respuesta.code === 200) {
                const idsToInvalidate = [id_work_order_exam, ...respuesta.data];

                let updateSections = sections.map(section => {
                    section.exams = section.exams.map(exam => {
                        if (idsToInvalidate.includes(exam.id_work_order_exam)) {
                            exam.isRelease = false;
                            exam.user = null;
                            exam.release_date = null;
                            exam.id_estatus_exam = 3;
                            exam.id_status = null;

                            exam.analytes = exam.analytes.map(analyte => {
                                analyte.userValidate = null;

                                if (analyte.capture) {
                                    analyte.capture.print_chart = false;
                                }

                                return analyte;
                            });
                        }
                        return exam;
                    });
                    return section;
                });

                let updateProfiles = profiles.map(perfil => {
                    perfil.exams = perfil.exams.map(exam => {
                        if (idsToInvalidate.includes(exam.id_work_order_exam)) {
                            exam.isRelease = false;
                            exam.user = null;
                            exam.release_date = null;
                            exam.id_estatus_exam = 3;
                            exam.id_status = null;

                            exam.analytes = exam.analytes.map(analyte => {
                                analyte.userValidate = null;

                                if (analyte.capture) {
                                    analyte.capture.print_chart = false;
                                }

                                return analyte;
                            });
                        }
                        return exam;
                    });

                    perfil.readyToValidateProfile = perfil.exams.some(ex => ![4, 6].includes(ex.id_estatus_exam));
                    perfil.readyToReleaseProfile = false;
                    return perfil;
                });
                // console.log("console.log de removeValidationFromExamOrProfile",updateSections === sections);
                setSections([...updateSections]);
                setProfiles([...updateProfiles]);
                const anyReleasedInSections = updateSections.some(sec =>
                    sec.exams.some(ex => ex.isRelease === true)
                );

                const anyReleasedInProfiles = updateProfiles.some(per =>
                    per.exams.some(ex => ex.isRelease === true)
                );

                const anyReleased = anyReleasedInSections || anyReleasedInProfiles;

                setPrintAvailable(anyReleased);
                setResultsPartial(anyReleased);
                setDobleValidacion(anyReleased);


                setListCurves(prevList =>
                    prevList.map(exam => {
                        if (idsToInvalidate.includes(exam.id_work_order_exam)) {
                            return {
                                ...exam,
                                curves: Array.isArray(exam.curves)
                                    ? exam.curves.map(curve => ({
                                        ...curve,
                                        id_user_validate: null,
                                        validated_at: null,
                                        released_at: null,
                                    }))
                                    : []
                            };
                        }
                        return exam;
                    })
                );

                setMicroBacteriums(prev =>
                    prev.map(micro => {
                        if (idsToInvalidate.includes(micro.id_work_order_exam)) {
                            return {
                                ...micro,
                                userValidate: false,
                                validated_at: "",
                                validated_by: "",
                                released_at: "",
                                released_by: ""
                            };
                        }
                        return micro;
                    })
                );

                setDisableMethodInput(true);



            } else if (respuesta.code === 401) {
                //validarSesion(history, respuesta.code, validateBacterium);
            } else if (respuesta.code === 500) {
                createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor");
            } else {
                createSweet("error", "warning", "Captura de resultados", respuesta.data.msg);
            }
        } catch (error) {
            console.error(error);
            createSweet("error", "error", "Captura de resultados", "Ocurrió un error inesperado");

        } finally {
            setLoadingRemoveCapture(prev => ({
                ...prev,
                [id_work_order_exam]: false
            }));

            endProcessingValidation();
        }
    };

    const updateMethod = async (id_work_order_exam) => {

        let requestOptions = {
            method: 'GET',
        };

        const respuesta = await sendRequest(requestOptions, "Exam/UpdateMethodExam/" + id_work_order_exam);

        if (respuesta.code === 200) {

            let updateSections = sections;
            let updateProfiles = profiles;

            updateSections.map(section => {
                let examenes = section.exams.map(exam => {
                    if (exam.id_work_order_exam === id_work_order_exam) {
                        exam.method_selected = respuesta.data;
                    }
                    return exam;
                })
                section.exams = [...examenes];
                return section;
            });


            updateProfiles.map(perfil => {
                let examenes = perfil.exams.map(exam => {
                    if (exam.id_work_order_exam === id_work_order_exam) {
                        exam.method_selected = respuesta.data;

                    }

                    return exam;
                })
                perfil.exams = [...examenes];
                return perfil;
            })

            setSections([...updateSections]);
            setProfiles([...updateProfiles]);
            createSweet("success", "success", "Captura de resultados", "Método actualizado correctamente.");
            window.location.reload();

        }
        else if (respuesta.code === 401) {
            //validarSesion(history, respuesta.code, validateBacterium);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Captura de resultados", "Ocurrio un problema en el servidor.");
        }
        else {
            createSweet("error", "warning", "Captura de resultados.", respuesta.data.msg);
        }

    }
    //END METOOD EXAMEN

    //#region PRESUMTIVE RESULTS
    //*ACTIONS PRESUNTIVE RESULTS
    const addPresumptiveResult = (id_work_order_exam, _type, examId, _sectionProfileId) => {

        let _presumptive = presumptive;

        let nuevo = {
            "id": Date.now(),
            "id_work_order_exam": id_work_order_exam,
            "close_capture_presumptive_result": false,
            "print_presumptive": false,
            "presumptives": [
                {
                    "id": Date.now(),
                    "id_presumptive_result": null,
                    "id_mic_stain": "",
                    "id_mic_stain_result": "",
                    "id_mic_bacterium": "",
                    "label_mic_stain": "",
                    "label_mic_stain_result": "",
                    "label_mic_bacterium": "",
                    "observations": "",
                    "time": "",
                    "id_work_order_exam": id_work_order_exam,
                    "isEdit": false,
                    "print_result": false,
                    "user_release": null,
                    "user_validate": null,
                }
            ]
        };

        const getPresuntive = _presumptive?.find(x => x.id_work_order_exam === id_work_order_exam);

        if (getPresuntive !== undefined) {
            getPresuntive.presumptives.push(
                {
                    "id": Date.now(),
                    "id_presumptive_result": null,
                    "id_mic_stain": "",
                    "id_mic_stain_result": "",
                    "id_mic_bacterium": "",
                    "label_mic_stain": "",
                    "label_mic_stain_result": "",
                    "label_mic_bacterium": "",
                    "observations": "",
                    "time": "",
                    "id_work_order_exam": id_work_order_exam,
                    "isEdit": false,
                    "print_result": false,
                    "user_release": null,
                    "user_validate": null,
                }
            );
        }
        else {
            _presumptive.push(nuevo);
        }

        setPresumptive([..._presumptive]);


        if (_type === "profile") {
            profiles.map(x => {
                let exams2 = x.exams.map(xx => {
                    if (xx.id_work_order_exam === id_work_order_exam) {
                        if (xx.presumptive_results !== undefined && xx.presumptive_results !== null) {
                            if (xx.presumptive_results?.length > 0) {

                            }
                            else {
                                xx.presumptive_results = [nuevo];
                            }
                        } else {
                            xx.presumptive_results = [nuevo];
                        }
                    }
                    return xx;
                })
                x.exams = [...exams2]
                return x;
            });

        }
        else {
            let updateSections = sections;
            updateSections.map(section => {
                if (section.id === _sectionProfileId) {
                    section.exams.map(exam => {
                        if (exam.id_exam === examId && exam.id_work_order_exam === id_work_order_exam) {
                            // console.log("paso aqui");
                            if (exam.presumptive_results !== undefined && exam.presumptive_results !== null) {
                                if (exam.presumptive_results?.length > 0) {

                                }
                                else {
                                    exam.presumptive_results = [nuevo];
                                }
                            } else {
                                exam.presumptive_results = [nuevo];
                            }
                            return exam;

                        }
                        return section;
                    })
                }
                return section;
            })
            setSections([...updateSections]);

        }

    }

    //!SAVE PRESUNTIVE FINAL
    const handleChangePresumptive = async (e, _id_work_order_exam, _type, examId, _sectionProfileId) => {

        let _valor = e.target.checked;

        if (_valor) {
            let _listTemp = await handleRequest("PUT", `Exam/LockPresumtiveResults/${_id_work_order_exam}`, "Global Impresion");

            if (_listTemp !== null) {

                createSweet("success", "success", "Reporte final", "Se a finalizado correctamente el reporte de presuntivos.");

                if (_type === "section") {
                    let updateSections = sections;
                    updateSections.map(section => {
                        if (section.id === _sectionProfileId) {
                            section.exams.map(exam => {
                                if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                    exam.presumptive_results.map(_presuntive => {
                                        _presuntive.close_capture_presumptive_result = _valor;
                                        return _presuntive;
                                    })
                                    return exam;
                                }
                                return section;
                            })
                        }
                        return section;
                    })
                    setSections([...updateSections]);
                } else {
                    let updateProfiles = profiles;
                    updateProfiles.map(perfil => {
                        if (perfil.id_profile === _sectionProfileId) {
                            perfil.exams.map(exam => {
                                if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                    exam.presumptive_results.map(_presuntive => {
                                        _presuntive.close_capture_presumptive_result = _valor;
                                        return _presuntive;
                                    })
                                }
                                return exam;
                            })
                        }
                        return perfil;
                    })
                    setProfiles([...updateProfiles]);
                }
            }
        }
        else {
            let _listTemp = await handleRequest("PUT", `Exam/UnlockPresumtiveResults/${_id_work_order_exam}`, "Global Impresion");

            if (_listTemp !== null) {

                createSweet("success", "success", "Reporte final", "Finalizado.");

                if (_type === "section") {
                    let updateSections = sections;
                    updateSections.map(section => {
                        if (section.id === _sectionProfileId) {
                            section.exams.map(exam => {
                                if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                    exam.presumptive_results.map(_presuntive => {
                                        _presuntive.close_capture_presumptive_result = _valor;
                                        return _presuntive;
                                    })
                                    return exam;

                                }
                                return section;
                            })
                        }
                        return section;
                    })
                    setSections([...updateSections]);
                } else {
                    let updateProfiles = profiles;
                    updateProfiles.map(perfil => {
                        if (perfil.id_profile === _sectionProfileId) {
                            perfil.exams.map(exam => {
                                if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                    exam.presumptive_results.map(_presuntive => {
                                        _presuntive.close_capture_presumptive_result = _valor;
                                        return _presuntive;
                                    })
                                }
                                return exam;
                            })
                        }
                        return perfil;
                    })
                    setProfiles([...updateProfiles]);
                }
                removePrintingGlobal(_id_work_order_exam, _type, examId, _sectionProfileId, "remove")
            }
        }
    }

    //!REMOVE PRESUNTIVE
    const removePresumptiveResult = async (_id_work_order_exam, _id_presuntive, _edition, _type) => {

        //!VARIBLES 
        let _presumptive = presumptive;

        _presumptive = _presumptive.map(_x => {
            if (_x.id_work_order_exam === _id_work_order_exam) {

                _x.presumptives = _x.presumptives.filter(_a => {
                    if (_a.id_presumptive_result === _id_presuntive) {
                        if (_a.isEdit) {
                            _a.id_presumptive_result = null;
                            _a.idDelete = true
                            return true;
                        } else {
                            return false;
                        }
                    } else {

                        return true;
                    }
                });
            }
            return _x;
        });

        setPresumptive([..._presumptive]);
    };

    //!PRINTING PRESUNTIVE RESULTS
    const PrintingPresumptiveResult = async (_id_work_order_exam, _id_presumptive, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/ActivePrintPresumtiveResults/${_id_presumptive}`, "Presuntivos Imprimir");

        if (_listTemp !== null) {

            createSweet("success", "success", "Impresión de presuntivos", "Se a activado correctamento la Impresión.");
            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive) {
                                            _find.print_result = true;
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);

            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive) {
                                            console.log(_find);
                                            _find.print_result = true;
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    };

    //!CANCEL PRINTING PRESUNTIVE
    const cancelPrintingPresumptive = async (_id_work_order_exam, _id_presumptive, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/DisablePrintPresumtiveResults/${_id_presumptive}`, "Presuntivos Imprimir");

        if (_listTemp !== null) {

            createSweet("success", "success", "Impresión de presuntivos", "Se a desactivado correctamento la impresión.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive) {
                                            _find.print_result = false;
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive) {
                                            _find.print_result = false;
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }

    //!CANCEL REMOVE PRESUMTIVE
    const cancelRemovePresumtiveResults = async (_id_work_order_exam, _id_presuntive, _edition, _type) => {
        //!VARIBLES 
        presumptive.forEach(_x => {
            if (_x.id_work_order_exam === _id_work_order_exam) {
                _x.presumptives.forEach(_a => {
                    if (_a.id_presumptive_result === _id_presuntive) {
                        _a.idDelete = false;
                    }
                });
            }
        });
        setPresumptive([...presumptive]);
    }

    //!PRINTING PRESUMTIVE RESULTS GLOBAL
    const printingGlobal = async (_id_work_order_exam, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/EnableGlobalPrintPresumtiveResults/${_id_work_order_exam}`, "Global Impresion");

        if (_listTemp !== null) {

            createSweet("success", "success", "Impresión Gloabal", "Se a activado correctamento la Impresión Global.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.print_presumptive = true;
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.print_presumptive = true;
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }

    //!PRINTING PRESUMTIVE RESULTS GLOBAL
    const removePrintingGlobal = async (_id_work_order_exam, _type, examId, _sectionProfileId, _validRemove) => {

        let _listTemp = await handleRequest("PUT", `Exam/DisableGlobalPrintPresumtiveResults/${_id_work_order_exam}`, "Global Impresion");

        if (_listTemp !== null) {

            //!VALIDATION REMOVE CHANGE PRESUMTIVE
            if (_validRemove === undefined) {
                createSweet("success", "success", "Impresión Gloabal", "Se a desactivado correctamento la Impresión Global.");
            }

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.print_presumptive = false;
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.print_presumptive = false;
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }
    //*END ACTIONS PRESUNTIVE RESULTS


    //*CONFIGURATIONS VALIDATIONS
    const valdatePresumtiveResults = async (_id_work_order_exam, _id_presumptive_result, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/ValidatePresumtiveResults/${_id_presumptive_result}`, "Presuntivos");

        if (_listTemp !== null) {

            createSweet("success", "success", "Validación de presuntivos", "Se a validado correctamente.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_validate = nameUser
                                            _find.validate_at = moment().format("D/M/YYYY hh:mm a")
                                            return _find;
                                        }
                                    })

                                    return _presuntive;
                                })
                                return exam;

                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_validate = nameUser
                                            _find.validate_at = moment().format("D/M/YYYY hh:mm a")
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }

    const unvalidatePresumtiveResults = async (_id_work_order_exam, _id_presumptive_result, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/UnvalidatePresumtiveResults/${_id_presumptive_result}`, "Presuntivos");

        if (_listTemp !== null) {

            createSweet("success", "success", "Validación de presuntivos", "Se a desvalidado correctamente.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_validate = null
                                            _find.validate_at = null
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_validate = null;
                                            _find.validate_at = null;
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }

    const ReleasePresumtiveResults = async (_id_work_order_exam, _id_presumptive_result, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/ReleasePresumtiveResults/${_id_presumptive_result}`, "Presuntivos");

        if (_listTemp !== null) {

            createSweet("success", "success", "Liberación de presuntivos", "Se a liberado correctamente.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_release = nameUser;
                                            _find.release_at = moment().format("D/M/YYYY hh:mm a");
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_release = nameUser;
                                            _find.release_at = moment().format("D/M/YYYY hh:mm a");
                                            return _find;
                                        }
                                    })
                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }

    const unreleasePresumtiveResults = async (_id_work_order_exam, _id_presumptive_result, _type, examId, _sectionProfileId) => {

        let _listTemp = await handleRequest("PUT", `Exam/UnreleasePresumtiveResults/${_id_presumptive_result}`, "Presuntivos");

        if (_listTemp !== null) {

            createSweet("success", "success", "Liberación de presuntivos", "Se a desvalidado correctamente.");

            if (_type === "section") {
                let updateSections = sections;
                updateSections.map(section => {
                    if (section.id === _sectionProfileId) {
                        section.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_release = null;
                                            _find.release_at = null;

                                            _find.user_validate = null;
                                            _find.validate_at = null;

                                            return _find;
                                        }
                                    })


                                    return _presuntive;
                                })
                                return exam;
                            }
                            return section;
                        })
                    }
                    return section;
                })
                setSections([...updateSections]);
            } else {
                let updateProfiles = profiles;
                updateProfiles.map(perfil => {
                    if (perfil.id_profile === _sectionProfileId) {
                        perfil.exams.map(exam => {
                            if (exam.id_exam === examId && exam.id_work_order_exam === _id_work_order_exam) {
                                exam.presumptive_results.map(_presuntive => {
                                    _presuntive.presumptives.map(_find => {
                                        if (_find.id_presumptive_result === _id_presumptive_result) {
                                            _find.user_release = null;
                                            _find.release_at = null;
                                            _find.user_validate = null;
                                            _find.validate_at = null;
                                            return _find;
                                        }
                                    })

                                    return _presuntive;
                                })
                            }
                            return exam;
                        })
                    }
                    return perfil;
                })
                setProfiles([...updateProfiles]);
            }
        }
    }


    //*VALIDATION SAVE PRESUMTIVE
    const validTestRanges = () => {
        let statusValidation = false;
        if (presumptive?.length > 0) {
            presumptive.forEach(_find => {
                _find.presumptives.forEach(_valid => {

                    // //!REQUIRED FIELDS fields
                    if (_valid.id_mic_stain === "" &&
                        _valid.id_mic_stain_result === "" &&
                        _valid.time === "" &&
                        _valid.id_mic_bacterium === "" &&
                        _valid.observations === "") {
                        statusValidation = true;
                    } else {
                        statusValidation = false;
                    }

                });
            });
        }
        else {
            statusValidation = true;
        }
        return statusValidation;
    }
    //*END VALIDATION SAVE PRESUMTIVE
    //*END CONFIGURATIONS VALIDATIONS

    //#endregion

    // #region COMMENT GLOBAL MICROBIOLOGY

    // ? NEW COMMENT GLOBAL
    const addCommentGlobal = (id_work_order_exam, _type, examId, _sectionProfileId) => {

        let _presumptive = microComments;

        let nuevo = {
            "id": Date.now(),
            "id_work_order_exam": id_work_order_exam,
            "global_comment": "",
            "global_result": "",
            "cedimi_micro_type_result": null,

        };

        const getPresuntive = _presumptive?.find(x => x.id_work_order_exam === id_work_order_exam);

        if (getPresuntive !== undefined) {

        }
        else {
            _presumptive.push(nuevo);
        }
        setMicroComments([..._presumptive]);


        if (_type === "profile") {
            profiles.map(x => {
                let exams2 = x.exams.map(xx => {
                    if (xx?.id_work_order_exam === id_work_order_exam) {
                        if (xx?.micro_global_comment !== undefined && xx?.micro_global_comment !== null) {
                            if (xx?.micro_global_comment?.length > 0) {

                            }
                            else {
                                xx.micro_global_comment = [nuevo];
                            }
                        } else {
                            xx.micro_global_comment = [nuevo];
                        }
                    }
                    return xx;
                })
                x.exams = [...exams2]
                return x;
            });

        }
        else {
            let updateSections = sections;
            updateSections.map(section => {
                if (section?.id === _sectionProfileId) {
                    section.exams.map(exam => {
                        if (exam?.id_exam === examId && exam.id_work_order_exam === id_work_order_exam) {
                            if (exam?.micro_global_comment !== undefined && exam?.micro_global_comment !== null) {
                                if (exam?.micro_global_comment?.length > 0) {

                                }
                                else {
                                    exam.micro_global_comment = [nuevo];
                                }
                            } else {
                                exam.micro_global_comment = [nuevo];
                            }
                            return exam;
                        }
                        return section;
                    })
                }
                return section;
            })
            setSections([...updateSections]);
        }
    }
    // ? NEW OBSERVATION
    const handleChangeIsolated = (e, _id_work_order_exam, _type, examId, _sectionProfileId) => {

        if (e !== null && e?.target?.value !== undefined) {
            let _newArray = microComments
            let _valid = _newArray.find(x => x.id_work_order_exam === _id_work_order_exam);

            if (_valid) {
                _valid.global_comment = e?.target?.value
            }
            if (_newArray?.length > 0)
                setMicroComments([..._newArray]);
        }
    }

    // ? NEW RESULT
    const handleChangeResult = (e, _id_work_order_exam, _type, examId, _sectionProfileId) => {

        if (e !== null && e?.target?.value !== undefined) {
            let _newArray = microComments
            let _valid = _newArray.find(x => x.id_work_order_exam === _id_work_order_exam);

            if (_valid) {
                _valid.global_result = e?.target?.value
            }
            if (_newArray?.length > 0)
                setMicroComments([..._newArray]);
        }
    }

    // ? NEW  TYPE RESULT
    const handleTypeResult = (_id_work_order_exam, _type, _id_exam, _section_profile_id, _type_result) => {

        let _valid_type_result = null;

        if (_type_result === 1) {
            _valid_type_result = true;
        } else if (_type_result === 0) {
            _valid_type_result = false;
        }

        if (_type === "section") {
            let updateSections = [...sections];
            updateSections.map(section => {
                if (section.id === _section_profile_id) {
                    section.exams.map(exam => {
                        if (exam?.id_exam === _id_exam && exam?.id_work_order_exam === _id_work_order_exam) {
                            if (exam?.cedimi_micro_type_result === true) {
                                exam.cedimi_micro_type_result = null;
                            } else if (exam?.cedimi_micro_type_result === false) {
                                exam.cedimi_micro_type_result = null;
                            } else if (exam?.cedimi_micro_type_result === null) {
                                exam.cedimi_micro_type_result = _valid_type_result;
                            }

                            const _presumptive = [...microComments];
                            const getPresuntive = _presumptive.find(x => x.id_work_order_exam === _id_work_order_exam);

                            if (getPresuntive !== undefined) {
                                getPresuntive.cedimi_micro_type_result = exam?.cedimi_micro_type_result;
                            } else {
                                _presumptive.push({
                                    id: Date.now(),
                                    id_work_order_exam: _id_work_order_exam,
                                    cedimi_micro_type_result: exam?.cedimi_micro_type_result,
                                    global_comment: null,
                                    global_result: null,
                                });
                            }
                            setMicroComments([..._presumptive]);
                        }
                        return exam;
                    });
                }
                return section;
            });
            setSections([...updateSections]);
        } else {
            let updateProfiles = [...profiles];
            updateProfiles.map(perfil => {
                if (perfil.id_profile === _section_profile_id) {
                    perfil.exams.map(exam => {
                        if (exam?.id_exam === _id_exam && exam?.id_work_order_exam === _id_work_order_exam) {
                            if (exam?.cedimi_micro_type_result === true) {
                                exam.cedimi_micro_type_result = null;
                            } else if (exam?.cedimi_micro_type_result === false) {
                                exam.cedimi_micro_type_result = null;
                            } else if (exam?.cedimi_micro_type_result === null) {
                                exam.cedimi_micro_type_result = _valid_type_result;
                            }

                            const _presumptive = [...microComments];
                            const getPresuntive = _presumptive.find(x => x.id_work_order_exam === _id_work_order_exam);

                            if (getPresuntive !== undefined) {
                                getPresuntive.cedimi_micro_type_result = exam.cedimi_micro_type_result;
                            } else {
                                _presumptive.push({
                                    id: Date.now(),
                                    id_work_order_exam: _id_work_order_exam,
                                    cedimi_micro_type_result: exam?.cedimi_micro_type_result,
                                    global_comment: null,
                                    global_result: null,
                                });
                            }
                            setMicroComments([..._presumptive]);
                        }
                        return exam;
                    });
                }
                return perfil;
            });
            setProfiles([...updateProfiles]);
        }
    };

    // #endregion

    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {

            return response.data;

        }
        else if (response.code === 409) {
        }
        else if (response.code === 500) {
        }
        else {
        }
        return null;
    }

    const printHistoricPdf = async (file) => {
        let token = localStorage.getItem("token");

        await fetch(`/api/WorkOrder/DownloadHistoricPDF/${file}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Resultado.pdf")
                document.body.appendChild(link)
                    ;
                link.style.display = 'none';
                link.click();

            })
    }


    // region Modal Comment global

    const toggleTableGlobalComment = () => {
        setModalTableGlobalComment(!modalTableGlobalComment);
    }
    const closeDialogComments = () => {
        setModalTableGlobalComment(false);
    };


    const toggleCrudComment = () => {
        setModalCrudComment(!modalCrudComment);
    }

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        text: "",
        type: 0,
        letter: false,



    });

    const { text, type, letter } = formValues;

    const [validaciones, setValidaciones] = useState({
        text: false,
    });

    const [keyComments, setKeyComments] = useState(null);
    const [dataComment, setDataComment] = useState(null)
    const [typeList, setTypeList] = useState(null);

    const handleCreateGlobalComment = (typeUI, typeListParam, _key, _micro) => {

        handleUpdateValues({
            text: "",
            type: typeUI
        });

        setMethod("create");
        setKeyComments(_key);
        setDataComment(_micro);

        setTypeList(typeListParam);

        toggleTableGlobalComment();
    };

    const saveCreate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        let newForm = {
            text: formValues.text,
            type: formValues.type,

        };

        let listTmp = await handleRequest("POST", "GlobalCommentText/Create", "Comentario Global", newForm);
        ////console.log('listTmp',listTmp)
        if (listTmp !== null) {
            setLoading(false);
            toggleCrudComment();
            createSweet("create", "success", "Comentario Creado");
            fetchComments(type, search);
        } else {
            setLoading(false);
            toggleCrudComment();

        }

    }

    const handleInsert = (rowData) => {
        const palabraSeleccionada = rowData.text;

        if (type === 1) {
            if (dataComment?.global_result) {
                dataComment.global_result += " " + palabraSeleccionada;
            } else {
                dataComment.global_result = palabraSeleccionada;
            }

        } else if (type === 2) {
            if (dataComment?.global_comment) {
                dataComment.global_comment += " " + palabraSeleccionada;
            } else {
                dataComment.global_comment = palabraSeleccionada;
            }

        } else if (type === 3) { // 👈 ESTE ES TU INPUT
            if (dataComment?.comment_resistance_mechanism) {
                dataComment.comment_resistance_mechanism += " " + palabraSeleccionada;
            } else {
                dataComment.comment_resistance_mechanism = palabraSeleccionada;
            }
        }

        createSweet("create", "success", "Texto Agregado");
        handleChangeResult({ ...dataComment });
    };

    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.text.trim() === "") {
            newValidaciones = {
                ...newValidaciones,
                text: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                text: false
            }
        }

        setValidaciones({
            ...validaciones,
            ...newValidaciones
        });

        return statusValidacion;
    }

    const [search, setSearch] = useState("");
    const fetchComments = async (type, search = "") => {
        setLoading(true);
        try {
            let token = localStorage.getItem("token");

            const response = await fetch(`/api/GlobalCommentText/List/${type}?search=${search}`, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            });

            if (response !== null) {
                const data = await response.json();
                setComments(data);
                setCommentsBackup(data);
            }

        } catch (error) {
            console.error("Error al obtener los comentarios:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (modalTableGlobalComment && typeList !== null) {

            setComments([]);
            setCommentsBackup([]);

            fetchComments(typeList, search);
        }
    }, [modalTableGlobalComment, typeList, search]);

    const [idDelete, setIdDelete] = useState(null);

    const openDeleteAlertText = () => {
        setShowDeleteAlert(true);
        setModalAlert(true);
    };

    const closeDeleteAlertText = () => {
        setModalAlert(false);
        setShowDeleteAlert(false);
    };

    const saveDeleteComment = async () => {
        if (!idDelete) return;

        try {
            let respuesta = await handleRequest(
                "DELETE",
                `GlobalCommentText/Delete/${idDelete}`,
                "Comentario"
            );

            if (respuesta !== null) {
                let array1 = comments.filter(
                    comment => comment.id_global_comment_text !== idDelete
                );

                setComments([...array1]);
                setCommentsBackup([...array1]);

                createSweet("success", "success", "El texto se ha eliminado correctamente.");
            }

            closeDeleteAlertText();
            setIdDelete(null);

        } catch (error) {
            createSweet("warning", "warning", "Error al eliminar el texto.");
        }
    };



    // endregion


    const handleRefresh = async (id_work_order_exam) => {
        setLoading(true);

        const isConfirmed = await sweetAcceptGlobal(
            "¿Está seguro de que desea borrar todos los resultados?\n\nEsta acción eliminará todos los resultados capturados del examen. En caso de aceptar, deberá seleccionar nuevamente la metodología utilizada y volver a ingresar los resultados.",
            "",
            "warning",
            true
        );

        if (isConfirmed) {
            try {
                let token = localStorage.getItem("token");

                const response = await fetch(`/api/Exam/RefreshWorkOrderExam/${id_work_order_exam}`, {
                    method: 'POST',
                    headers: new Headers({
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    })
                });


                if (response !== null) {
                    setProfiles(prev => ({
                        ...prev,
                        id_exam_method: null,
                        id_estatus_exam: 1,
                        analytes: [],
                    }));

                    createSweet("create", "success", "Borrado Exitoso");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);

                }
                else {
                    createSweet("error", "error", "Error al borrar los resultados")
                }

            } catch (error) {
                console.error("Error al refrescar los campos", error);
            } finally {
                setLoading(false);
            }
        }
    };

    // ? CONFIGURATION QUESTION SAMPLING



    //? PDF BITACORA 
    const printBitacoraMedica = async (workOrderId) => {
        let token = localStorage.getItem("token");

        await fetch(`/api/WorkOrder/DownloadMicroBinnaculum/${workOrderId}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })

            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", " Bitácora de Microbiología Médica.pdf")
                document.body.appendChild(link)
                    ;
                link.style.display = 'none';
                link.click();

            })
    }

    /// List exam print 

    const togglePrintI = () => {
        setModalPrintI(!modalPrintI);
    }

    // const handleListPrint = async (id_work_order) => {

    //     let _listTmp = await handleRequest("GET", `WorkOrder/GetExambyWorkOrder/${id_work_order}`, 'invoice');

    //     if (_listTmp !== null) {
    //         let dataExamsTemp = [];
    //         _listTmp.forEach((data, index) => {
    //             if (data.listExam != "[]") {
    //                 data.listExam.forEach((data, index) => {
    //                     dataExamsTemp.push({
    //                         "id_work_order_exam": data.id_work_order_exam,
    //                         "id_work_order_profile": null,
    //                         "id_estatus": data.id_estatus,
    //                         "id_profile": null,
    //                         "id_exam": data.id_exam,
    //                         "name": data.name,
    //                         "listExam": [],
    //                         "check_box": false,
    //                         "sendBy": data.sendBy,
    //                         "show_print": data.show_print

    //                     });
    //                 });

    //             }
    //             if (data.listProfile != "[]") {
    //                 data.listProfile.forEach((data, index) => {
    //                     dataExamsTemp.push({
    //                         "id_work_order_exam": data.id_work_order_exam,
    //                         "id_work_order_profile": data.id_work_order_profile,
    //                         "id_estatus": data.id_status,
    //                         "id_profile": data.id_profile,
    //                         "id_exam": null,
    //                         "name": data.name_profile,
    //                         "listExam": data.listExam,
    //                         "check_box": false,
    //                         "gatos": 155,
    //                         "show_print": data.show_print

    //                     });
    //                 });
    //             }
    //             setid_workorder_print(id_work_order);
    //             setdataExams(dataExamsTemp);
    //             setTypeModalPrintI("viewPrintI")
    //             togglePrintI();
    //         });
    //     }
    // }


    const handleCheckProfile = (e, id_profile, id_exam, id_work_order_profile, id_work_order_exam) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;
        let elementToUpdate = copyTest.find(x => id_profile != null && id_exam != null ?
            x.id_work_order_profile === id_work_order_profile && x.id_profile === id_profile :
            x.id_work_order_exam === id_work_order_exam && x.id_exam === id_exam);
        if (elementToUpdate) {
            if (id_profile != null && id_exam != null) {
                elementToUpdate.listExam.map(i => {
                    if (i.id_exam == id_exam) {
                        i.check_box = valor;
                    }
                    return i;
                });

            } else {
                elementToUpdate.check_box = valor;
            }
        }
        setdataExams(copyTest);
    };




    const handleCheckAll = (e) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;

        if (copyTest) {
            copyTest.map(x => {
                if (!x.show_print) {
                    return;
                }
                if ((x.id_estatus >= 6 && x.id_estatus <= 10) || x.id_estatus == 12
                    || x.id_estatus == 13 || x.id_estatus == 15 || x.id_estatus == 18 || x.id_estatus == 5 || x.id_estatus == 21 || (x.id_estatus >= 2 && x.id_estatus <= 4)) {
                    x.check_box = valor;
                    x.listExam.map(i => {
                        if (!i.show_print) {
                            return;
                        }
                        if ((i.id_estatus >= 6 && i.id_estatus <= 10) || i.id_estatus == 12
                            || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {
                            i.check_box = valor;
                        }
                        return i;
                    });
                }
                return x;
            });
        }

        setdataExams(copyTest);
    };


    const Impresionbyexam = async (workOrderId) => {


        let _valid = false


        dataExams.forEach(_valid1 => {
            if (_valid1.check_box === true) {
                _valid = _valid1.check_box
            }
            _valid1.listExam.forEach(_f => {
                if (_f.check_box === true) {
                    _valid = _f.check_box
                }
            });
        });


        let payload = {
            "nim": nimPatient,
            "password": "",
            "type": "NP",
            "lista_exames": dataExams,
            "letter": letter,
        }

        if (_valid !== false) {


            let data = JSON.stringify(payload);
            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResultsByExam?is_printed=true", {
                method: 'POST',
                body: data,
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se ha podido descargar el pdf");
                        return;
                    }
                    return response.blob();
                })
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "hoja_resultados_" + nim + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                    createSweet("success", "success", "Descarga completa");
                });
        }
        else {
            createSweet("warning", "warning", "Debe de seleccionar al menos un estudio para poder imprimir");

        }
    }


    const handleCheckAllProfile = (e, id_profile, id_work_order_profile) => {
        let copyTest = [...dataExams];
        let valor = e.target.checked;
        let elementToUpdate = copyTest.find(x => x.id_work_order_profile === id_work_order_profile
            && x.id_profile == id_profile);

        if (elementToUpdate) {
            elementToUpdate.check_box = valor;
            elementToUpdate.listExam.map(i => {
                if (!i.show_print) {
                    return false;
                }
                if ((i.id_estatus >= 6 && i.id_estatus <= 10) || i.id_estatus == 12
                    || i.id_estatus == 13 || i.id_estatus == 15 || i.id_estatus == 18 || i.id_estatus == 5 || i.id_estatus == 21 || (i.id_estatus >= 2 && i.id_estatus <= 4)) {

                    i.check_box = valor;
                }
                return i;
            });
        }


        setdataExams(copyTest);
    };

    //#region SAMPLING
    const getUniqueQuestions = () => {
        return Array.from(
            new Set(
                dataQuestionSampling
                    .map(q => q.question.trim())
                    .filter(p => p.toLowerCase() !== '¿estudios?')
            )
        );
    };


    // Process the table rows based on the questions

    const generateTableRows = () => {
        const rows = [];
        let currentBlock = [];
        let lastExam = '';

        dataQuestionSampling.forEach(item => {
            currentBlock.push(item);

            const question = item.question.trim().toLowerCase();

            if (question.includes('flebotomista')) {

                const blockRows = processBlock(
                    currentBlock,
                    lastExam
                );

                if (blockRows[0]?.exam) {
                    lastExam = blockRows[0].exam;
                }

                rows.push(...blockRows);

                currentBlock = [];
            }
        });

        return rows;
    };


    const processBlock = (block, lastExam) => {
        const examName = block.find(
            b => b.question.trim().toLowerCase() === '¿estudios?'
        )?.answer || lastExam;
        const answerRow = { type: 'Answers', exam: examName };

        block.forEach(({ question, answer }) => {
            const key = question.trim().toLowerCase();

            if (key === '¿estudios?') return;

            if (!key.includes('comentario') && !key.includes('flebotomista')) {
                answerRow[key] = answer || '';
            }
        });

        const tomas = [];
        let currentComent = '';
        let hasTomas = false;
        let generalComent = '';
        let generalFlebotomista = '';

        block.forEach(({ question, answer }) => {
            const key = question.trim().toLowerCase();

            if (key.includes('comentario de tomas')) {
                currentComent = answer;
                hasTomas = true;
            } else if (key.includes('flebotomista que realizó la toma')) {
                tomas.push({
                    type: 'Toma',
                    exam: examName,
                    comentario: currentComent && currentComent.trim() !== "" ? currentComent : "Sin comentario",
                    flebotomista: answer || ''
                });
                currentComent = '';
                hasTomas = true;
            } else if (key.includes('comentario') && !key.includes('comentario de tomas')) {
                generalComent = answer || '';
            } else if (key.includes('flebotomista') && !key.includes('flebotomista que realizó la toma')) {
                generalFlebotomista = answer || '';
            }
        });
        if (!hasTomas && (generalComent || generalFlebotomista)) {
            tomas.push({
                type: 'Toma',
                exam: examName,
                comentario: generalComent,
                flebotomista: generalFlebotomista,
                isGeneral: true
            });
        }

        const hasAnswers =
            Object.keys(answerRow)
                .filter(k => k !== 'type' && k !== 'exam')
                .length > 0;

        return [
            ...(hasAnswers ? [answerRow] : []),
            ...tomas
        ];
    };


    const calculateRowSpan = (rows) => {
        const spanMap = {};
        let currentExam = '';
        let startIndex = 0;
        let count = 0;

        rows.forEach((row, index) => {
            if (row.exam === currentExam) {
                count++;
            } else {
                if (count > 0) {
                    spanMap[startIndex] = count;
                }
                currentExam = row.exam;
                startIndex = index;
                count = 1;
            }
        });

        if (count > 0) {
            spanMap[startIndex] = count;
        }

        return spanMap;
    };

    const uniqueQuestions = getUniqueQuestions();
    const tableRows = generateTableRows();
    const rowSpanMap = calculateRowSpan(tableRows);



    // #region Curves
    const handleChangeCurveResult = (idExam, curveIndex, newValue) => {
        // console.log(`[handleChangeCurveResult] idExam: ${idExam}, curveIndex: ${curveIndex}, newValue: ${newValue}`);
        const updated = listCurves.map(exam => {
            if (exam.id_exam === idExam) {
                const updatedCurves = exam.curves.map((curve, idx) => {
                    if (idx === curveIndex) {
                        return { ...curve, result: newValue };
                    }
                    return curve;
                });
                return { ...exam, curves: updatedCurves };
            }
            return exam;
        });

        // console.log(`[handleChangeCurveResult] updated:`, updated);

        setListCurves(updated);
    };


    const handleChangeCurveTime = (idExam, curveIndex, selected) => {
        setListCurves(prevList => {
            const newList = prevList.map(exam => {
                if (String(exam.id_exam) === String(idExam)) {
                    const updatedCurves = exam.curves.map((curve, idx) => {
                        if (idx === curveIndex) {
                            return {
                                ...curve,
                                id_curve_time: selected.value,
                                label_curve_time: selected.label,
                                time_in_minutes: selected.time_in_minutes,
                            };
                        }
                        return curve;
                    });
                    return { ...exam, curves: updatedCurves };
                }
                return exam;
            });

            return newList;
        });
    };

    // const validateCurves = () => {
    //     let invalid = false;

    //     listCurves.forEach(exam => {
    //         exam.curves.forEach(c => {
    //             if (c.result !== null && c.result !== '' && typeof c.range === 'string' && c.range.includes('-')) {
    //                 const [min, max] = c.range.split('-').map(s => parseFloat(s.trim()));
    //                 if (!isNaN(min) && !isNaN(max)) {
    //                     if (parseFloat(c.result) < min || parseFloat(c.result) > max) {
    //                         invalid = true;
    //                     }
    //                 }
    //             }
    //         });
    //     });

    //     return invalid;
    // };

    const handleResetResultCurves = async (id_work_order_exam, num_sampling) => {
        let requestOptions = {
            method: 'POST'
        };

        const response = await sendRequest(requestOptions, `Exam/RefreshExamCurveSampling/${id_work_order_exam}/${num_sampling}`);

        if (response.code === 200) {
            createSweet("create", "success", "Toma limpiada correctamente");

            setListCurves(prevListCurves => {
                return prevListCurves.map(exam => {
                    if (exam.id_work_order_exam === id_work_order_exam) {
                        return {
                            ...exam,
                            curves: exam.curves.map(curve => {
                                if (curve.num_sampling === num_sampling) {
                                    return { ...curve, result: null };
                                }
                                return curve;
                            })
                        };
                    }
                    return exam;
                });
            });

        } else if (response.code === 500) {
            createSweet("error", "error", "Analito", "Ocurrió un problema en el servidor");
        }
    };

    const fetchExamMethodData = async (id_work_order_exam, methodId) => {
        if (!id_work_order_exam || !methodId) return null;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id_work_order_exam: id_work_order_exam,
                id_method: methodId
            })
        };

        try {
            const respuesta = await sendRequest(requestOptions, 'Exam/GetCurveRanges');
            // console.log('seleccionar curvas, entra')
            return respuesta;
        } catch (error) {
            // console.error("Error en fetchExamMethodData:", error);
            return null;
        }
    };

    useEffect(() => {

        const allExams = [
            ...(sections?.flatMap(s => s.exams || []) || []),
            ...(profiles?.flatMap(p => p.exams || []) || [])
        ];

        if (allExams.length === 0) {
            setAllValidated(false);
            return;
        }

        const allStatusOne = allExams.every(ex => ex.id_estatus_exam === 1);

        setAllValidated(!allStatusOne);

    }, [sections, profiles]);

    const canPreview =
        (Array.isArray(sections) && sections.some(s =>
            s.exams?.some(e => e.id_estatus_exam === 4 || e.isRelease)
        )) ||
        (Array.isArray(profiles) && profiles.some(p =>
            p.exams?.some(e => e.id_estatus_exam === 4 || e.isRelease)
        ));


    // #endregion


    //#region DIALOG PRINT AND SEND

    const [sendConfig, setSendConfig] = useState({
        send_email: false,
        send_doctor: false,
        send_whatsapp: false,
        send_whatsapp_doctor: false,
        print_results: false
    });

    const [id_workorder_send, setid_workorder_send] = useState(0);
    const [typeModalExamEmail, setTypeModalExamEmail] = useState("viewExamEmail");
    const [modalExamsEmail, setModalExamsEmail] = useState(false);
    const [modalCheckEmail, setModalCheckEmail] = useState(false);
    const [dataSend, setDataSend] = useState([]);
    const [sendTo, setSendTo] = useState([]);
    const [nimSend, setNimSend] = useState(0);
    const [respuestaAPI, setRespuestaAPI] = useState({});
    const [openProfiles, setOpenProfiles] = useState({});
    const [markAllActive, setMarkAllActive] = useState(false);
    const [step, setStep] = useState(1);
    const [auditPanel, setAuditPanel] = useState(null);
    const [sending, setSending] = useState(false);

    const toggleListExamEmail = () => {
        setModalExamsEmail(!modalExamsEmail);
    }


    const toggleExamEmail = () => {
        setModalCheckEmail(!modalCheckEmail)
    }

    const handleListExamEmail = async (id_work_order) => {

        let _listTmp = await handleRequest("GET", `WorkOrder/GetExambyWorkOrder/${id_work_order}`, 'invoice');

        if (_listTmp !== null) {
            let dataExamsTemp = [];
            _listTmp.forEach((item) => {
                if (item.listExam && item.listExam.length > 0) {
                    item.listExam.forEach((exam) => {
                        dataExamsTemp.push({
                            nim: item.nim,
                            id_work_order_exam: exam.id_work_order_exam,
                            id_work_order_profile: null,
                            id_estatus: exam.id_estatus,
                            id_profile: null,
                            id_exam: exam.id_exam,
                            name: exam.name,
                            listExam: [],
                            check_box: false,
                            show_print: exam.show_print,
                            has_been_send: exam.has_been_send,
                            sendBy: exam.sendBy,
                            total_sends: exam.total_sends,
                            sends_to_patient: exam.sends_to_patient,
                            sends_to_doctor: exam.sends_to_doctor,
                            last_send_date: exam.last_send_date,
                            patient_audit_details: exam.patient_audit_details ?? [],
                            doctor_audit_details: exam.doctor_audit_details ?? [],
                            print_audit_details: exam.print_audit_details ?? [],
                        });

                    });

                }
                if (item.listProfile && item.listProfile.length > 0) {
                    item.listProfile.forEach((profile) => {
                        dataExamsTemp.push({
                            nim: item.nim,
                            id_work_order_exam: 0,
                            id_work_order_profile: profile.id_work_order_profile,
                            id_estatus: profile.id_status,
                            id_profile: profile.id_profile,
                            id_exam: null,
                            name: profile.name_profile,
                            listExam: profile.listExam,
                            sent_exams: profile.sent_exams ?? 0,
                            total_exams: profile.total_exams ?? profile.listExam.length,
                            status_profile: profile.status_profile ?? "",
                            check_box: false,
                            show_print: profile.show_print,
                            patient_audit_details: profile.patient_audit_details ?? [],
                            doctor_audit_details: profile.doctor_audit_details ?? [],
                            print_audit_details: profile.print_audit_details ?? [],
                        });
                    });
                }
            });

            const config = _listTmp[0];

            setSendConfig({
                send_email: config.send_email ?? false,
                send_doctor: config.send_doctor ?? false,
                send_whatsapp: config.send_whatsapp ?? false,
                send_whatsapp_doctor: config.send_whatsapp_doctor ?? false,
                print_results: config.show_print ?? false,
            });


            setid_workorder_send(id_work_order);
            setdataExams(dataExamsTemp);
            setTypeModalExamEmail("viewExamEmail");
            toggleListExamEmail();
        }
    }

    const sendResultEmail = async (sendDoctor) => {

        let payload = {
            nim: nim,
            password: "",
            type: "NP",
            doctor: sendDoctor,
            lista_exames: dataExams
        };

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(payload)
        };

        const respuesta = await sendRequest(requestOptions, "PrintResult/SendResultForEmailByExam");

        if (respuesta.code === 200) {
            return true;
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, sendResultEmail);
            return false;
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Resultados", respuesta.data.msg);
            return false;
        }
        else {
            createSweet("error", "warning", "Resultados", respuesta.data.msg);
            return false;
        }
    };


    const handleSendExam = async (id_workOrder) => {

        setSendTo(patient);
        setNimSend(nim);
        toggleExamEmail();
    }

    const handleFindExam = () => {

        let checkExam = dataExams.find(w => w.check_box === true)

        let individual = [];
        let profile = [];
        let profiles = [];

        dataExams.forEach((data, index) => {
            individual.push({
                "check_box": data.check_box,
            })
            profile.push({
                "listExam": data.listExam
            });
        });

        profile.forEach((data, index) => {

            data.listExam.forEach((check) => {
                profiles.push({
                    "check_box": check.check_box,
                })
            })
        })

        let checkIndividual = false;
        let checkProfiles = false;
        let _checkIndividualTemp = individual.find(w => w.check_box)
        if (_checkIndividualTemp !== undefined) {
            checkIndividual = _checkIndividualTemp.check_box
        }

        let _checkProfilesTemp = profiles.find(w => w.check_box);
        if (_checkProfilesTemp !== undefined) {
            checkProfiles = _checkProfilesTemp.check_box;
        }

        if (checkIndividual === true || checkProfiles === true) {
            setModalExamsEmail(!modalExamsEmail);
            if (modalExamsEmail === true) {
                handleSendExam();
            }
        }
        else {
            createSweet("", "warning", "Advertencia", "No se ha seleccionado ningún examen");
        }
    }


    const resetModalExamEmail = () => {
        setStep(1);
        setdataExams([]);
        setSendConfig({
            send_email: false,
            send_doctor: false,
            send_whatsapp: false,
            send_whatsapp_doctor: false

        });
        setAuditPanel(null);
    };

    const handleSendEmail = async ({ sendPatient, sendDoctor, printResult }) => {

        if (!sendPatient && !sendDoctor && !printResult) return;

        if (sending) return;

        try {

            setSending(true);

            let results = [];

            if (printResult) {

                const id = id_workorder_send;

                await Impresionbyexam(id);

            }

            if (sendPatient) {
                results.push(await sendResultEmail(false));
            }

            if (sendDoctor) {
                results.push(await sendResultEmail(true));
            }

            const allSent = results.every(r => r === true);

            if (allSent || printResult) {

                createSweet(
                    "create",
                    "success",
                    "Éxito!",
                    "Los resultados se han procesado correctamente"
                );

                toggleListExamEmail();
                getData();
            }

        } finally {
            setSending(false);
        }
    };

    const handleMarkAllClick = () => {
        setMarkAllActive(!markAllActive);
        handleCheckAll({
            target: { checked: !markAllActive }
        });
    };


    const selectedCount = dataExams.reduce((total, item) => {
        if (item.id_profile === null) {
            return total + (item.check_box ? 1 : 0);
        }

        if (item.listExam?.length > 0) {
            return total + item.listExam.filter(e => e.check_box).length;
        }

        return total;
    }, 0);

    const statusMap = {
        1: { label: "Abierto", class: "status-info" },
        2: { label: "En Progreso", class: "status-warning" },
        3: { label: "Capturado", class: "status-warning" },
        4: { label: "Validado", class: "status-warning" },
        5: { label: "Parcial", class: "status-warning" },
        6: { label: "Liberado", class: "status-warning" },

        7: { label: "Entregado", class: "status-success" },
        8: { label: "Entregado", class: "status-success" },
        9: { label: "Entregado", class: "status-success" },
        10: { label: "Entregado", class: "status-success" },
        11: { label: "Modificada", class: "status-warning" },
        12: { label: "Entregado", class: "status-success" },
        13: { label: "Entregado", class: "status-success" },
        14: { label: "Pendiente", class: "status-warning" },
        15: { label: "Entregado", class: "status-success" },
        17: { label: "Desvalidado", class: "status-primary" },
        18: { label: "Entregado", class: "status-success" },

        20: { label: "Cancelado", class: "status-danger" },
        21: { label: "Entregado", class: "status-success" }
    };


    const getStatus = (status) => {
        let config = statusMap[status] || { label: "-", class: "" };

        if (status === 13 && _url_helen === labcen) {
            return {
                ...config,
                label: "Impreso",
                class: "status-warning"
            };
        }

        return config;
    };


    const isSelectable = (estatus, show_print) => {
        if (!show_print) return false;

        return (
            (estatus >= 6 && estatus <= 10) ||
            estatus === 12 ||
            estatus === 13 ||
            estatus === 15 ||
            estatus === 18 ||
            estatus === 5 ||
            estatus === 21 ||
            (estatus >= 2 && estatus <= 4)
        );
    };

    const toggleAuditPanel = (type, examId, data, nameExam) => {
        // console.log("😺 auditPanel", auditPanel);
        if (

            auditPanel &&
            auditPanel.type === type &&
            auditPanel.examId === examId &&
            auditPanel.nameExam === nameExam
        ) {


            setAuditPanel(null);
            return;
        }

        setAuditPanel({
            type,
            examId,
            data,
            nameExam
        });
    };


    const getFullAuditHistory = (exam) => {

        const all = [
            ...(exam.patient_audit_details || []),
            ...(exam.doctor_audit_details || []),
            ...(exam.print_audit_details || [])
        ];

        return all.sort((a, b) => new Date(b.send_date) - new Date(a.send_date));
    };



    useEffect(() => {

        const main = document.querySelector('.results-digital-modal.p-dialog');

        if (!main) return;

        const observer = new ResizeObserver(entries => {
            const audit = document.querySelector('.audit-dialog.p-dialog');
            if (audit) {
                audit.style.height = entries[0].target.offsetHeight + "px";
            }
        });

        observer.observe(main);

        return () => observer.disconnect();

    }, [modalExamsEmail, auditPanel]);


    useEffect(() => {
        if (!modalExamsEmail) {
            resetModalExamEmail();
        }
    }, [modalExamsEmail]);

    const toggleProfile = (id) => {
        setOpenProfiles(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    //#endregion

    //coment
    const handleExportExcelComment = async () => {
        setLoadingExport(true);
        try {
            const XLSX = await import("xlsx");

            const _report = comments.map((item, index) => ({
                "#": index + 1,
                Comentarios: item.text ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Comentarios Globales");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_comentarios_globales.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    const [searchComment, setSearchComment] = useState("");
    const [commentsBackup, setCommentsBackup] = useState([]);

    const handleSearch = (e) => {
        setSearchComment(e);

        let busqueda = e.toUpperCase();

        let filtrados = commentsBackup.filter(element =>
            element.text.toUpperCase().includes(busqueda)
        );

        setComments(filtrados);
    };

    const handleClear = () => {
        setSearchComment("");
        localStorage.removeItem("globalFilter");
        setComments(comments);
    };

    //#region history patient

    const getResultsHistory = async (id_exam) => {

        if (!idp || !id_exam) return null;

        let requestOptions = {
            method: 'GET',
        };

        const response = await sendRequest(
            requestOptions,
            `Reports/ExportResultsExamsPatientJson/${idp}?id_exam=${id_exam}`
        );

        return response.data ?? null;
    };


    const getNimsData = (data, exam) => {

        const ordersSorted = [...data.work_orders]
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        return ordersSorted.filter(order => {

            const hasAnalyte = exam.analytes.some(a =>
                a.results.some(r =>
                    r.id_work_order === order.id_work_order &&
                    r.result !== null &&
                    r.result !== "" &&
                    r.result !== "-"
                )
            );

            const hasAntibiogram = exam.antibiograms?.some(a =>
                a.id_work_order === order.id_work_order &&
                (
                    (a.bacteriums && a.bacteriums.length > 0)
                )
            );

            return hasAnalyte || hasAntibiogram;
        });
    };


    const buildHistoryResults = (data, idExam) => {

        const exam = data.exams.find(e => e.id_exam === idExam);
        if (!exam) return [];

        const orders = getNimsData(data, exam);

        const rows = [];

        exam.analytes.forEach(a => {

            const row = {
                tipo: "analito",
                analito: a.analyte
            };

            orders.forEach((order, index) => {
                const val = a.results.find(r => r.id_work_order === order.id_work_order)?.result;
                row[`nim_${index}`] = val ?? "-";
            });

            rows.push(row);
        });

        if (exam.antibiograms?.length > 0) {

            rows.push({
                tipo: "separador_micro",
                analito: "MICROORGANISMOS AISLADOS"
            });



            const microRow = {
                tipo: "antibiograma",
                analito: "MICROORGANISMO"
            };

            orders.forEach((order, index) => {

                const anti = exam.antibiograms.find(a => a.id_work_order === order.id_work_order);

                microRow[`nim_${index}`] = {
                    bacterias: anti?.bacteriums || [],
                    comentario: anti?.micro_global_comment || "-",
                    resultado: anti?.micro_global_result || "-"
                };
            });

            rows.push(microRow);
        }

        return rows;
    };


    let currentRequest = 0;

    const handleHistorico = async (examen) => {

        const requestId = ++currentRequest;

        setSelectedExam(examen);
        setVisibleSidebar(true);
        setHistoricoData([]);
        setHistoricoRaw(null);
        setLoadingHistorico(true);

        const data = await getResultsHistory(examen.id_exam);

        if (requestId !== currentRequest) return;

        if (!data) {
            setLoadingHistorico(false);
            return;
        }

        const tableData = buildHistoryResults(data, examen.id_exam);

        setHistoricoRaw(data);
        setHistoricoData(tableData);
        setLoadingHistorico(false);
    };



    //     load();
    // }, [idp]);
    //

    const hasHistorico = (examen) => {

        if (!examen?.analytes) return false;

        return examen.analytes.some(a =>
            Array.isArray(a.results) &&
            a.results.some(r =>
                r.result !== null &&
                r.result !== "" &&
                r.result !== "-"
            )
        );
    };



    //#endregion

    //#region Hospitalizado
    const handleGetHospitalizationHistory = async (_idPatient) => {

        if (!_idPatient || _idPatient <= 0) {
            setHospitalizationHistory([]);
            return;
        }

        setLoadingHospitalizationHistory(true);

        let requestOptions = {
            method: 'GET'
        };

        const response = await sendRequest(
            requestOptions,
            `WorkOrder/GetHistoricHospitalized/${_idPatient}`
        );

        if (response.code === 200) {
            setHospitalizationHistory(response.data ?? []);
        }
        else if (response.code === 401) {
            validarSesion(
                history,
                response.code,
                () => handleGetHospitalizationHistory(_idPatient)
            );
        }
        else {
            setHospitalizationHistory([]);
        }

        setLoadingHospitalizationHistory(false);
    };

    const handleOpenHospitalizationHistory = async () => {

        if (!idp) {
            return;
        }

        setVisibleHospitalizationHistory(true);

        await handleGetHospitalizationHistory(idp);
    };

    //#endregion

    return {
        loadingButton, analytes, profiles, sections, patient, listDoctors, sendDoctor, saveIndividualAnalyte, saveAllAnalytes, releaseExam, releaseAll, validateAnalyte, validateExam, validateProfile, printAvailable, dobleValidacion, resultsPartial, printWorkOrder, sendResultForEmail,
        observations, commentsPrintResult, handleEditCommentsPrintResults, saveCommentsWorkOrder,
        microBacteriums, addMicroAislado, microAntibiograms,
        nimPatient, commentsFlebo, workMedicalOrder, workMedicalOrderPDF, workMedicalOrderPDFLoading, workMedicalOrderPDFDownload, type_file,
        handleCreate, toggle, method, modal, modalTitle1, typeModal, modalRelease, openDialogRelease, closeDialogRelease, loadingRelease, getViewPreview, previewWorkOrder,
        saveIndividualExamImagenology, handleGetDocumentImagenology, modalViewImagenology, modalTitleImg, toggleModalViewImagenology, documentImagenology, loadingPatient,
        removeValidationFromExamOrProfile, updateMethod, paid, credit_payment, setAnalytes,
        backNim, nextNim, gotoNim, typeModalMedical, toggleMedical, modalMedical,
        // * BACTERIUMS
        microAntibiotics, setMicroAntibiotics, setMicroBacteriums, handleTypeBacterium, handleChangeComments, removeBacterium1, removeBacteriumAntibitic,
        ValidateBacterium, UnValidateBacterium, ReleaseBacterium, UnReleaseBacterium,

        // * PRESUMPTIVE
        addPresumptiveResult, presumptive, setPresumptive, removePresumptiveResult, handleChangePresumptive, PrintingPresumptiveResult, cancelRemovePresumtiveResults, printingGlobal, cancelPrintingPresumptive, removePrintingGlobal,

        // * VALIDATIONS PRESUMTIVE RESULTS
        valdatePresumtiveResults, ReleasePresumtiveResults, unvalidatePresumtiveResults, unreleasePresumtiveResults,

        // * CONFIGURATION
        taptopStyle, executeScroll,

        // * COMMENT GLOBAL
        handleChangeIsolated, microComments, addCommentGlobal, handleChangeResult, handleTypeResult,

        printHistoricPdf, pdf_historic, historicMode, pdf_without_letter,

        //*Modal comment global
        toggleTableGlobalComment, modalTableGlobalComment, handleCreateGlobalComment, toggleCrudComment, modalCrudComment,
        saveCreate, handleInputChange, text, type, comments, loading, search, setSearch,
        keyComments, handleInsert,

        //*Refresh work Order Exam
        handleRefresh,

        // ? CONFIGURATION QUESTION SAMPLING
        dataQuestionSampling,

        //* BITACORA
        microBinnacleCedimi, printBitacoraMedica, workOrderId,

        //* List exam print 
        togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile,

        //* TABLE clinical Infromation
        uniqueQuestions, tableRows,

        //* CURVES
        listCurves, handleChangeCurveResult, handleChangeCurveTime, disabledInputFollowUp, handleResetResultCurves,
        company,

        //*
        fetchExamMethodData, setListCurves, disableMethodInput,
        loadingValidateCapture, loadingReleaseExamCapture, loadingRemoveCapture, loadingValidateProfileC,
        idWChart, codeAgreement,
        countSample, validCount, allValidated,

        canPreview, closeDialog, loadingPdf, letter,

        //* DIALOG PRINT AND SEND
        handleListExamEmail, toggleListExamEmail, modalExamsEmail, handleFindExam, sendResultEmail, resetModalExamEmail,
        setStep, sendConfig, handleSendEmail, sending, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
        isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, getFullAuditHistory,
        saveDeleteComment, closeDeleteAlertText, openDeleteAlertText, modalAlert, showDeleteAlert, setIdDelete, loadingExport, handleExportExcelComment,
        searchComment, handleSearch, handleClear, closeDialogComments, handleFullUnvalidate, getStatus, _url_helen,
        getResultsHistory, selectedExam, visibleSidebar, historicoRaw, historicoData, setSelectedExam, setVisibleSidebar, setHistoricoRaw,
        setHistoricoData, handleHistorico, setLoadingHistorico, loadingHistorico, getNimsData, hasHistorico,

        _capture_lock,

        //? Historial patient
        showResistanceView,
        setShowResistanceView, showReloadLoader,

        //? HOSPITALIZADO
        hospitalization, hospitalizationComment,
        visibleHospitalizationHistory, setVisibleHospitalizationHistory,

        loadingHospitalizationHistory, hospitalizationHistory, handleOpenHospitalizationHistory,
        hasHospitalization,
        // ? CONFIGURATION DYNAMIC-CONSENT
        listAnswer,
        getAnswerText,
        setSurveyPage,
        totalSurveyPages,
        visibleSurveys,
        surveysPerPage,
        surveyPage,
        semlab,

        processingValidation,
        deleteCommentsWorkOrder

    }
}
